/* ==============================================================
   SleepHappy Promo / Free Gift Engine V5.0.9 — Nested Line Item Filter
   V5.0.9: User saw 3rd gift line on cart page NOT tagged (still showed
   discount code + qty controls). Root cause: cart page renders nested
   line items — outer <tr class="hdt-cart-item"> contains inner
   <div class="hdt-line-item"> inside its <td>. Both matched our line
   item selector. The inner div consumed a queue entry meant for a
   different outer <tr>, causing the LAST gift row to have no queue
   entry left → not tagged → controls leaked.
   FIX: Filter uniqueLines to keep only OUTERMOST line items (drop any
   line that has a line-item ancestor in the set). Plus added retry scans
   at 500ms + 1500ms after refresh to handle slow DOM render edge cases.
   V5.0.8: V5.0.7 fixed table clobber by skipping refresh on /cart page,
   but introduced regression — sync changes cart state server-side, but
   UI never updates → user sees stale qty (gift line stuck at qty=4 etc).
   FIX: Added refreshCartPage() that fetches /?sections=main-cart and
   replaces ONLY the cart page's main-cart contents — preserves table
   structure but updates qty/totals/lines properly. Used on /cart page.
   V5.0.7: CRITICAL — refreshCartDrawer() was destroying /cart page table.
   Root cause: querySelector('cart-items-component') returned the FIRST one
   in DOM, which on /cart page is the cart page's own component — NOT the
   drawer's. Then innerHTML replacement put drawer's div-list HTML into
   cart page's <table> structure → layout chaos.
   FIX: Scope selector to 'hdt-cart-drawer cart-items-component' so it only
   targets the drawer. Plus on /cart page, skip DOM swap entirely (Halo
   handles its own cart page update natively — we only need to dispatch events).
   V5.0.6: V5.0.4/5 broke cart page table layout when user clicked +/-
   on parent qty. Root cause: CSS used [class*="quantity"] / [class*="remove"]
   wildcards which matched <td class="hdt-cart-item__quantity"> on cart
   page table — hiding entire table cells → broken row alignment.
   FIX: Replaced wildcards with specific widget element/class selectors.
   Hides <hdt-quantity-wrapp>, <wrapp-remove-item-oncart> directly without
   affecting parent <td> cells. Also debounced burst scan via scheduleScan.
   V5.0.5: V5.0.4 fix didn't work on /cart page because attachPageObserver
   used wrong selector (.hdt-cart-page) — Halo's actual class is .hdt-page-cart
   (words swapped). Also outer wrapper is <hdt-main-cart> web component.
   FIX: Updated selector to hdt-main-cart, .hdt-page-cart, #hdt-page-cart.
   Added explicit /cart URL detection + immediate scan on cart page.
   V5.0.4: BUG — When cart had >1 gift with same variant_id (customer
   picks same color twice), only first gift line got sh-gift-line-item
   class → second gift leaked discount code "VQW73GK6Q9EF" badge.
   ROOT CAUSE: tagGiftLinesInDom() used document.querySelector (returns
   ONE element) instead of iterating ALL DOM lines. Also no observer
   for cart page (/cart).
   FIX: Rewrote to iterate ALL line items + queue-based matching (each
   gift key consumed once). Extended setupCartObserver to watch cart
   page form too.
   V5.0.3: Variant Read Priority Fix
   V5.0.3: ROOT CAUSE found — getCurrentVariantId() was reading
   <input name="id"> FIRST, but Halo updates this input ASYNC after
   user clicks. Result: stale variant ID → autoLockSize used wrong
   parent size → gift didn't change.
   FIX: Inverted priority — compute from CHECKED RADIOS first (sync,
   single source of truth). Hidden input becomes lowest fallback.
   Also: getParentVariant() now ALWAYS returns a variant (never undef).
   V5.0.2: Options Fallback
   V5.0.2: Auto-lock size still didn't work because shCurrentProduct
   was missing the "options" array (only had variants). Without option
   names, code couldn't tell which option was "size".
   FIX: Added 4-source detection in getParentOptionValueByType:
   1) shCurrentProduct.options (now populated by sh-promo-loader)
   2) Halo's fieldset.is-style-size class
   3) Radio input name attribute
   4) Pattern match value (e.g. "X ฟุต")
   Plus: sh-promo-loader.liquid now outputs options + current_variant_id.
   V5.0.1: Variant Sync Fix
   V5.0.1: Fix gift size NOT auto-locking when parent size changes.
   ROOT CAUSE: getCurrentVariantId() read from <input name="id"> which
   Halo updates ASYNC (lags the radio change event by ~10-50ms).
   FIX: getCurrentVariantId() now COMPUTES variant ID from checked
   radios SYNCHRONOUSLY — catches change immediately.
   Plus: variant tracking added to polling. Plus: explicit listener
   for hdt-variant-picker radio changes (was missing).
   V5.0: Smart Gift Matching
   V5.0: Two major UX features:
   1) AUTO-LOCK gift size to parent product size — if customer picks
      6 ฟุต bed, the gift bedding is automatically 6 ฟุต too. Customer
      can NOT change it. Picker UI hides the size option, shows a
      navy info pill "🔗 ขนาด: 6 ฟุต — ตรงตามที่คุณเลือก".
      Auto-select also for any single-value option (color if 1).
   2) STICKY ATC GUARD on mobile — if customer clicks "หยิบใส่ตะกร้า"
      while gifts not picked → blocks click + toast warning + smooth
      scrolls to gift card + shake animation (red border flash).
      Capture phase listener so blocks BEFORE Halo's handler fires.
   V4.9.2: Price Bug Fix
   V4.9.2: BUG FIX — gift price was 100x too high (showed ฿79,000 instead
           of ฿790). Liquid outputs prices in CENTS (integer) but JS was
           treating it as baht. Fixed computeGiftValue to /100.
           Bonus: now uses PER-INSTANCE variant prices when customer
           picks different colors with different prices.
   V4.9.1: Safe + Optimistic
   V4.9.1: REVERTED parallel fetch (broke gift add reliability).
           Sequential flow restored: parent ATC → response → gift add.
           Optimistic UI MOVED to AFTER gift response confirmed:
           - User sees gifts ~50ms after gift /cart/add succeeds
           - Real section refresh in background swaps silently
           - Discount applied? Auto re-refresh after
           Net result: gifts ALWAYS appear (reliability) + ~150ms speed
           saved vs V4.8 (no waiting for full section render to see gifts)
   V4.9: Parallel + Optimistic UI (reverted — broke add)
   V4.9: ULTRA-FAST cart drawer — user sees gifts ~100-200ms after click
         ⚡ PARALLEL fetches: parent /cart/add + gift /cart/add concurrent
            (no setTimeout wait, no sequential chain, both start at T=0)
         ⚡ OPTIMISTIC UI: gift line items INJECTED into drawer DOM BEFORE
            server response. User sees them as drawer opens (~100ms).
            Real section refresh swaps them silently (~500ms).
         ⚡ fetch keepalive=true (request survives page nav)
         ⚡ rAF yield for Halo's logic queue
         Network RTT saved: ~300-400ms (one full round-trip eliminated)
         Perceived UX: instant (drawer opens with gifts already visible)
   V4.8: Cart Speed Optimization
   V4.8: Cart drawer now shows gifts ~600-800ms after ATC (was ~1800ms)
         - Discount cookie WARMED at page load (sessionStorage flag)
           → ATC no longer blocks on /discount/CODE apply (~400ms saved)
         - setTimeout 200ms → 30ms (170ms saved)
         - refreshCartDrawer fires IMMEDIATELY after gift add
           (parallel with discount apply if needed)
         - Slim section fetch: cart-drawer + cart-icon-bubble (was 5 sections)
         - Removed redundant scanCartForGifts(400) + syncGiftQuantities(800)
         - Console timing logged: t0 → response → drawer refreshed
   V4.7: Swap Position
   V4.7: Gift card mount now positions ABOVE installment badge
         (.sh-pdp-inst-badge). Visual order: Gift → Installment → ATC.
         Auto-corrects if installment badge renders after gift mount.
   V4.6: Flag Ribbon Redesign
   V4.6: Completely redesigned ribbon as HORIZONTAL FLAG PENNANT
         - Larger readable text (14.5px, was tiny 13.5px uppercase)
         - Gift emoji 🎁 icon before text
         - Swallowtail V-cut on RIGHT (flag fluttering out)
         - Triple drop-shadow for premium 3D lift
         - Gloss highlight top + subtle bottom shade + left fold
         - Happy entrance: slide down + scale + rotate bounce
         - Positioned overhanging TOP-RIGHT (classic ribbon style)
         - Card padding-top increased so ribbon doesn't overlap content
         - Mobile: text still 13.5px (readable), adjusted padding
   V4.5: Happy & Minimal
   V4.5: Removed redundant header text block ("ของแถมฟรี" + subtitle)
         Changed picker bg: yellow-cream → cool blue tint (#F4F8FF→#E8F0FF)
         Redesigned ribbon: 3D depth with gloss highlight + fold shadows +
         playful entrance animation (scale bounce w/ rotate)
         Hero value now inline compact strip (when value > 0 only)
         Instance badge: gold → brand navy (consistent)
         Mobile: ribbon resized properly for small screens
   V4.4: Clean & Refined
   V4.4: Outer card → light white/blue tint (was heavy dark navy).
         Replaced gold stamp pill with RED BOOKMARK RIBBON "แถมฟรี"
         (clip-path V-cut, sticks above card edge — like product tag).
         Hero amount → solid red (no gold gradient — cleaner).
         Title → ink black (was white). Reduced shadow drama.
         Item card → simple white with subtle border (no glow halo).
   V4.3: Readability + Font Fix
   V4.3: BUG FIX — picker is INSIDE white item card (not on navy directly)
         → restyled picker, size pills, swatches, status for LIGHT bg
         "เลือกขนาด" label was gold-on-light (invisible) → now dark with gold accent bar
         Size pills text was white-on-white (invisible) → now dark navy
         Bumped all Thai text +2-3px for legibility (DB Thin needs space)
         Removed font-weight reliance (site override forces 400) — use SIZE
         Force font-family on .sh-gift-card * for full coverage
   V4.2: Premium Navy Theme
   V4.2: Replaced pale-yellow BG with deep navy gradient (brand #2D54B1)
         Gold accents now GLOW on dark navy (high contrast premium)
         Inner item card stays white = "lifts" off dark navy with shadow
         Glassmorphism (backdrop-blur) on pickers + multi-instance
         Hero ฿289 = 38px gold gradient with drop-shadow glow
         Stamp = solid gold pill with golden halo
   V4.1: Editorial refinement
   V4.1: Removed redundant gift messaging (3x → 1x). Replaced noisy ribbon
         with minimal "INCLUDED" stamp pill. Hero value now 36px (true focal).
         Auto-fallback gift value from variant compare_at_price if admin
         didn't set value. Auto-hide single-option pickers (no more
         lonely 1-option swatches). Cleaner editorial layout.
   V4.0: Corner ribbon, hero value display (฿289 in 28px gradient type),
         color swatches (not dropdowns), size pill buttons, count badge
         on gift image, strikethrough original price + FREE pill,
         dramatic type scale 11/13/15/28, multi-layer premium shadows
   ==============================================================
   V3.3.2 — sh-promo.js
   V3.3.2: Hide tax/shipping note + agree-terms checkbox in cart drawer.
           Auto-check required agree box + remove required attr so checkout
           still submits (required-but-hidden would otherwise block).
   V3.3.1: Fix gift sync UI not updating after parent qty change in cart drawer
           - refreshCartDrawer now swaps cart-items-component (preserves dialog)
           - Sync calls refreshCartDrawer after server-side changes apply
           - Better logging to diagnose sync issues
   ==============================================================
   V3.3 Major hardening pass:
   - SAFE cart line detection (key-based, never text-match — no false positives)
   - SAFE discount-code hiding (only ACTUAL discount nodes, scoped to known
     gift line keys)
   - sessionStorage persistence for selections (survives page reloads)
   - Bulletproof Halo cart drawer refresh (Section Render API + DOM swap)
   - Coexists with sh-installment-suite.js fetch wrapper
   - All hooks via __shPatched flag (no double-wrapping)
   ============================================================== */
(function () {
  'use strict';

  /* Debug logger — gated behind window.__shDebug flag.
     Real warnings/errors (console.warn / console.error) stay unconditional. */
  function _shLog() { if (window.__shDebug) console.log.apply(console, arguments); }

  var STORAGE_KEY = 'sh_gift_selections_v1';

  /* customerGiftSelections[giftKey] = [variant_id_1, variant_id_2, ...]
     Index = instance number. null if not selected. */
  var customerGiftSelections = {};
  /* giftSameForAll[giftKey] = true/false. Default true (use [0] for all). */
  var giftSameForAll = {};

  /* Persist customer selections so they survive page navigation/reload */
  function loadSelections() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data && data.selections) customerGiftSelections = data.selections;
      if (data && data.sameForAll) giftSameForAll = data.sameForAll;
    } catch (e) {}
  }
  function saveSelections() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        selections: customerGiftSelections,
        sameForAll: giftSameForAll,
        ts: Date.now()
      }));
    } catch (e) {}
  }
  loadSelections();

  function loadConfig() {
    if (window.shPromoConfig && window.shPromoConfig.rules) return window.shPromoConfig;
    /* V5.8 SAFEGUARD (2026-05-24): page did NOT inject window.shPromoConfig — meaning the
       sh-promo-rules section is disabled in admin (section.settings.enabled = false). Any
       value in localStorage is STALE from a prior session when V3 was enabled, and would
       otherwise cause ghost gift cards to render on Mega Sale / Atlantis / Hotel PDPs
       (image 1 in 2026-05-24 Boss report). Clear the stale cache so init() bails cleanly. */
    try { localStorage.removeItem('shPromoConfig'); window.shPromoConfig = null; } catch (e) {}
    return null;
  }

  function getLocale() { return location.pathname.indexOf('/en/') !== -1 ? 'en' : 'th'; }

  function L(cfg, key) {
    var loc = getLocale();
    var k = key + '_' + loc;
    if (cfg && cfg.wording && cfg.wording[k]) return cfg.wording[k];
    var fallback = {
      title_th: '🎁 ของแถมพิเศษ', title_en: '🎁 Free Gifts',
      badge_th: '+ของแถม', badge_en: '+Free Gift',
      value_th: 'มูลค่ารวม', value_en: 'Total value',
      gift_label_th: 'ของแถม', gift_label_en: 'Free Gift',
      added_toast_th: '✓ เพิ่มของแถมในตะกร้าแล้ว', added_toast_en: '✓ Free gifts added',
      choose_size_th: 'เลือกขนาด', choose_color_th: 'เลือกสี',
      choose_option_th: 'เลือก',
      please_select_th: 'กรุณาเลือกตัวเลือกของแถมก่อน',
      please_select_en: 'Please select gift options first'
    };
    return fallback[k] || '';
  }

  function getCurrentProduct() { return window.shCurrentProduct || null; }

  function isProductTargeted(cfg) {
    if (!cfg || !cfg.enabled) return false;
    var p = getCurrentProduct();
    if (!p) return false;
    if (p.gifts_override && p.gifts_override.length > 0) return true;
    if (cfg.apply_everywhere) return true;
    if (cfg.target_collection && p.collections && p.collections.indexOf(cfg.target_collection) !== -1) return true;
    if (cfg.target_tag && p.tags && p.tags.indexOf(cfg.target_tag) !== -1) return true;
    return false;
  }

  function getCurrentVariantId() {
    /* PRIORITY 1 — Compute from currently checked radios (SYNC, reliable).
       Halo's <input name="id"> is updated ASYNC, so reading checked
       radios is the SINGLE SOURCE OF TRUTH for current selection. */
    var checkedOpts = [];
    document.querySelectorAll('hdt-variant-picker fieldset.hdt-product-form__input').forEach(function (fs) {
      var idx = parseInt(fs.dataset.index || '0', 10);
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) {
        checkedOpts[idx] = checked.value;
      } else {
        var hidden = fs.querySelector('input[is-value][type="hidden"]');
        if (hidden && hidden.value) checkedOpts[idx] = hidden.value;
      }
    });
    if (checkedOpts.length > 0) {
      var p = getCurrentProduct();
      if (p && p.variants) {
        var match = p.variants.find(function (v) {
          return (checkedOpts[0] == null || v.option1 === checkedOpts[0]) &&
                 (checkedOpts[1] == null || v.option2 === checkedOpts[1]) &&
                 (checkedOpts[2] == null || v.option3 === checkedOpts[2]);
        });
        if (match) return match.id;
      }
    }

    /* PRIORITY 2 — <hdt-variant-picker selected-variant> attribute */
    var picker = document.querySelector('hdt-variant-picker[selected-variant]');
    if (picker) {
      var sv = picker.getAttribute('selected-variant');
      if (sv) return sv;
    }

    /* PRIORITY 2.5 — CHECKED radio among form id inputs. The redesigned PDP
       (fieldset.sh-redesign-pdp__size-cards) uses <input name="id" type="radio">
       NOT wrapped in hdt-variant-picker, so the plain querySelector below would
       grab the FIRST radio (always 3.5ft) instead of the selected size. */
    var checkedId = document.querySelector('form[action*="/cart/add"] input[name="id"]:checked');
    if (checkedId && checkedId.value) return checkedId.value;

    /* PRIORITY 3 — hidden form input (may be stale, but better than nothing) */
    var sels = [
      'form[action*="/cart/add"] input[name="id"]',
      'form[action*="/cart/add"] select[name="id"]',
      '[data-variant-id]'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) {
        var v = el.value || el.dataset.variantId;
        if (v) return v;
      }
    }

    /* PRIORITY 4 — first available variant */
    var p2 = getCurrentProduct();
    if (p2 && p2.variants) {
      var firstAvail = p2.variants.find(function (v) { return v.available; });
      if (firstAvail) return firstAvail.id;
    }
    return null;
  }

  /* Read PDP qty input — falls back to 1.
     IMPORTANT: Halo theme puts qty input OUTSIDE the form (uses form="..." attr),
     so we cannot scope by form ancestor. We scan all qty inputs and pick the
     visible main one (not the sticky bar duplicate). */
  function getParentQuantity() {
    /* Halo class first, then generic selectors */
    var allInputs = document.querySelectorAll(
      'input.hdt-quantity__input, input[name="quantity"], hdt-quantity-input input, hdt-quantity input, [data-quantity-input] input'
    );
    var bestValue = 0;
    var bestSelector = '';
    for (var i = 0; i < allInputs.length; i++) {
      var el = allInputs[i];
      /* Skip sticky bar duplicates — they often have stale value */
      var id = el.id || '';
      if (/sticky/i.test(id)) continue;
      /* Visibility check — skip if completely hidden (display:none) */
      var visible = el.offsetParent !== null || el.type === 'hidden';
      if (!visible) continue;
      var v = parseInt(el.value, 10);
      if (v > 0 && v > bestValue) {
        bestValue = v;
        bestSelector = el.className || el.name || el.id;
      }
    }
    if (bestValue > 0) {
      _shLog('[SH Promo] qty input found (' + bestSelector + ') =', bestValue);
      return bestValue;
    }
    /* Fallback: any quantity input (including sticky) */
    for (var k = 0; k < allInputs.length; k++) {
      var inp = allInputs[k];
      var v2 = parseInt(inp.value, 10);
      if (v2 > 0) {
        _shLog('[SH Promo] qty fallback =', v2);
        return v2;
      }
    }
    _shLog('[SH Promo] qty input not found, default=1');
    return 1;
  }

  /* How many gift instances total for this gift definition?
     scale_with_parent === false → fixed perUnit
     else → perUnit × parentQty */
  function getGiftInstanceCount(g, parentQty) {
    var perUnit = parseInt(g.qty, 10) || 1;
    var scale = g.scale_with_parent !== false;
    var pq = parseInt(parentQty, 10) || 1;
    var count = scale ? perUnit * pq : perUnit;
    _shLog('[SH Promo] instanceCount: gift=', g.title || g.handle, 'perUnit=', perUnit, 'parentQty=', pq, 'scale=', scale, 'count=', count);
    return Math.max(1, count);
  }

  /* Get effective selection for instance idx — falls back to [0] if sameForAll */
  function getSelectionAt(giftKey, idx) {
    var arr = customerGiftSelections[giftKey] || [];
    var sameForAll = giftSameForAll[giftKey] !== false; /* default true */
    if (sameForAll) return arr[0] || null;
    return arr[idx] != null ? arr[idx] : null;
  }
  function getVariantById(vid) {
    var p = getCurrentProduct();
    if (!p || !p.variants) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(vid)) return p.variants[i];
    }
    return null;
  }
  function matchRule(rule, variant) {
    if (!rule.match) return true;
    var m = rule.match;
    if (m.option_value && variant) {
      if (variant.option1 !== m.option_value && (variant.title || '').indexOf(m.option_value) === -1) return false;
    }
    if (m.option_value2 && variant) {
      if (variant.option2 !== m.option_value2 && (variant.title || '').indexOf(m.option_value2) === -1) return false;
    }
    return true;
  }

  function getApplicableRules(variantId, opts) {
    opts = opts || {};
    var p = getCurrentProduct();
    var cfg = loadConfig();
    if (!cfg) return [];
    var rules = [];

    if (p && p.gifts_override && p.gifts_override.length > 0) {
      rules.push({
        id: 'product_override',
        trigger: 'always',
        label_th: p.gifts_label || 'ของแถมพิเศษสำหรับสินค้านี้',
        label_en: p.gifts_label || 'Special gifts for this product',
        gifts: p.gifts_override
      });
    }

    if (cfg.rules && cfg.rules.length > 0) {
      var variant = variantId ? getVariantById(variantId) : null;
      for (var i = 0; i < cfg.rules.length; i++) {
        var r = cfg.rules[i];
        if (r.trigger === 'always') rules.push(r);
        else if (r.trigger === 'variant' && variant) { if (matchRule(r, variant)) rules.push(r); }
        else if (r.trigger === 'threshold' && opts.includeThreshold) {
          var min = (r.match && r.match.min_subtotal) || 0;
          if ((opts.subtotal || 0) >= min) rules.push(r);
        }
      }
    }
    return rules;
  }

  /* ===== VARIANT RESOLUTION ===== */

  /* Find variant in gift product matching admin's input "Large" or "Large,White" */
  function resolveAdminVariant(gift) {
    if (!gift.variants || gift.variants.length === 0) return gift.default_variant_id;
    if (gift.has_only_default_variant) return gift.variants[0].id;
    var input = (gift.admin_variant || '').trim();
    if (!input) {
      /* No admin variant → first available */
      var v0 = gift.variants.find(function(v){ return v.available; }) || gift.variants[0];
      return v0.id;
    }
    var parts = input.split(',').map(function(s){ return s.trim(); });
    var size = parts[0];
    var color = parts[1] || null;
    /* Match by option1 + option2 */
    var match = gift.variants.find(function(v){
      var sMatch = !size || v.option1 === size || (v.title || '').indexOf(size) !== -1;
      var cMatch = !color || v.option2 === color || (v.title || '').indexOf(color) !== -1;
      return sMatch && cMatch && v.available;
    });
    return match ? match.id : gift.default_variant_id;
  }

  /* Returns ARRAY of variant_ids — one per instance.
     - Admin pre-select: all instances use same variant
     - Customer choose + sameForAll: all use [0]
     - Customer choose + per-instance: use individual selection
     Returns null entries for instances not yet selected (validated upstream). */
  function getGiftVariantIds(gift, giftKey, instanceCount) {
    instanceCount = Math.max(1, instanceCount || 1);
    var ids = new Array(instanceCount);
    if (!gift.let_customer_choose) {
      var adminVid = resolveAdminVariant(gift);
      for (var i = 0; i < instanceCount; i++) ids[i] = adminVid;
      return ids;
    }
    /* Customer choose */
    var sameForAll = giftSameForAll[giftKey] !== false; /* default true */
    var arr = customerGiftSelections[giftKey] || [];
    if (sameForAll) {
      var first = arr[0] || null;
      for (var k = 0; k < instanceCount; k++) ids[k] = first;
    } else {
      for (var m = 0; m < instanceCount; m++) ids[m] = arr[m] != null ? arr[m] : null;
    }
    return ids;
  }

  /* Backward-compat single-id helper (used by legacy code paths) */
  function getGiftVariantId(gift, giftKey) {
    if (!gift.let_customer_choose) return resolveAdminVariant(gift);
    var arr = customerGiftSelections[giftKey] || [];
    return arr[0] || null;
  }

  /* Find variant matching customer's option choices */
  function findVariantByOptions(gift, option1, option2, option3) {
    return gift.variants.find(function(v){
      var match = true;
      if (option1 != null && v.option1 !== option1) match = false;
      if (option2 != null && v.option2 !== option2) match = false;
      if (option3 != null && v.option3 !== option3) match = false;
      return match;
    });
  }

  /* ===== PDP GIFT CARD RENDER =====
     Mount placement: ABOVE the installment badge (sh-pdp-inst-badge) if
     it exists, otherwise BEFORE the buy-button wrapper item.
     This ensures visual order: Gift card → Installment → Add to cart. */
  function findGiftMount() {
    var existing = document.querySelector('[data-sh-gift-mount]');
    if (existing) {
      /* Re-check position — ensure still above installment badge.
         If installment appeared AFTER mount was created, mount might be
         in wrong position. Re-mount if needed. */
      var inst = document.querySelector('.sh-pdp-inst-badge');
      if (inst) {
        /* Check DOM order: existing should come BEFORE inst */
        var pos = existing.compareDocumentPosition(inst);
        /* DOCUMENT_POSITION_FOLLOWING = 4 → inst comes AFTER existing → correct */
        if (!(pos & Node.DOCUMENT_POSITION_FOLLOWING)) {
          /* Mount is AFTER inst — move it BEFORE inst */
          inst.parentNode.insertBefore(existing, inst);
        }
      }
      return existing;
    }

    /* First mount: find the BEST anchor */
    var atc = document.querySelector('form[action*="/cart/add"]');
    if (!atc) return null;

    /* Find the buy-button wrapper (product-info__item containing the form) */
    var buyWrap = atc.closest('.hdt-product-info__item') || atc;

    /* Prefer inserting BEFORE the installment badge (so gift appears first) */
    var instBadge = document.querySelector('.sh-pdp-inst-badge');
    var anchor = instBadge || buyWrap;
    if (!anchor || !anchor.parentNode) return null;

    var mount = document.createElement('div');
    mount.setAttribute('data-sh-gift-mount', '');
    anchor.parentNode.insertBefore(mount, anchor);
    return mount;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Determine which option values are pre-selected (from saved variant_id) */
  function getPreselectedOptions(gift, variantId) {
    if (!variantId || !gift.variants) return [null, null, null];
    var v = gift.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (!v) return [null, null, null];
    return [v.option1 || null, v.option2 || null, v.option3 || null];
  }

  /* Known color name → hex (Thai + English). Fallback = gray */
  var COLOR_SWATCHES = {
    'ขาว': '#FFFFFF', 'white': '#FFFFFF', 'สีขาว': '#FFFFFF',
    'ดำ': '#1A1A1A', 'black': '#1A1A1A', 'สีดำ': '#1A1A1A',
    'เทา': '#9CA3AF', 'grey': '#9CA3AF', 'gray': '#9CA3AF', 'สีเทา': '#9CA3AF',
    'น้ำเงิน': '#2D54B1', 'blue': '#2D54B1', 'สีน้ำเงิน': '#2D54B1', 'navy': '#1E3A8A',
    'ฟ้า': '#38BDF8', 'light blue': '#38BDF8', 'สีฟ้า': '#38BDF8', 'sky': '#38BDF8',
    'แดง': '#DC2626', 'red': '#DC2626', 'สีแดง': '#DC2626',
    'ชมพู': '#EC4899', 'pink': '#EC4899', 'สีชมพู': '#EC4899',
    'เหลือง': '#FCD34D', 'yellow': '#FCD34D', 'สีเหลือง': '#FCD34D', 'ทอง': '#EBB31F',
    'เขียว': '#10B981', 'green': '#10B981', 'สีเขียว': '#10B981', 'mint': '#6EE7B7',
    'ม่วง': '#8B5CF6', 'purple': '#8B5CF6', 'สีม่วง': '#8B5CF6',
    'ส้ม': '#F97316', 'orange': '#F97316', 'สีส้ม': '#F97316',
    'ครีม': '#FEF3C7', 'cream': '#FEF3C7', 'beige': '#F5F5DC', 'สีครีม': '#FEF3C7',
    'น้ำตาล': '#92400E', 'brown': '#92400E', 'สีน้ำตาล': '#92400E'
  };
  function getSwatchColor(value) {
    if (!value) return null;
    var key = String(value).toLowerCase().trim();
    if (COLOR_SWATCHES[key]) return COLOR_SWATCHES[key];
    /* Check partial match */
    for (var k in COLOR_SWATCHES) {
      if (key.indexOf(k.toLowerCase()) !== -1) return COLOR_SWATCHES[k];
    }
    return null;
  }

  function isColorOption(optName) {
    return /color|colour|สี/i.test(optName || '');
  }
  function isSizeOption(optName) {
    return /size|ขนาด|bedding|เตียง|ที่นอน/i.test(optName || '');
  }

  /* ===== PARENT-OPTION READERS =====
     Read currently-selected option values from the PARENT product's variant.
     Used to auto-match gift size to bed size. */
  function getParentVariant() {
    var p = getCurrentProduct();
    if (!p || !p.variants) return null;
    var vid = getCurrentVariantId();
    /* Always return SOMETHING — never undefined */
    if (vid) {
      var byId = p.variants.find(function (v) { return String(v.id) === String(vid); });
      if (byId) return byId;
    }
    return p.variants.find(function (v) { return v.available; }) || p.variants[0] || null;
  }

  /* Returns parent's selected option value matching the type (size|color).
     Multiple sources (most reliable first):
     1. shCurrentProduct.options array (from sh-promo-loader)
     2. Halo's <fieldset.is-style-size> class
     3. Read radio input name (= option name)
     4. Match by VALUE pattern (e.g. "X ฟุต" implies size) */
  function getParentOptionValueByType(type) {
    var p = getCurrentProduct();
    var v = getParentVariant();
    if (!v) return null;

    /* Source 1: shCurrentProduct.options */
    var opts = (p && p.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var n = (typeof opts[i] === 'string') ? opts[i] : (opts[i].name || '');
      if (type === 'size' && isSizeOption(n)) return v['option' + (i + 1)];
      if (type === 'color' && isColorOption(n)) return v['option' + (i + 1)];
    }

    /* Source 2 & 3: Halo's fieldsets — class is-style-size or radio name */
    var fieldsets = document.querySelectorAll('hdt-variant-picker fieldset.hdt-product-form__input');
    for (var f = 0; f < fieldsets.length; f++) {
      var fs = fieldsets[f];
      var fsIdx = parseInt(fs.dataset.index || '0', 10);
      var optionName = '';
      var radio = fs.querySelector('input[type="radio"]');
      if (radio) optionName = radio.name || '';
      var styleMatch = false;
      if (type === 'size' && (fs.classList.contains('is-style-size') || isSizeOption(optionName))) styleMatch = true;
      if (type === 'color' && (fs.classList.contains('is-style-color') || isColorOption(optionName))) styleMatch = true;
      if (styleMatch) {
        return v['option' + (fsIdx + 1)];
      }
    }

    /* Source 4: pattern-match the variant value itself */
    if (type === 'size') {
      for (var oi = 1; oi <= 3; oi++) {
        var val = v['option' + oi];
        if (val && /\d+(?:\.\d+)?\s*ฟุต|ft|inch/i.test(val)) return val;
      }
    }
    return null;
  }

  /* Find variant in gift product matching a specific option-index/value combo,
     while preserving other already-selected options. */
  function findGiftVariantWithOption(g, currentVid, optionIdx, value) {
    if (!g.variants) return null;
    var current = currentVid ? g.variants.find(function (v) { return String(v.id) === String(currentVid); }) : null;
    var opts = [null, null, null];
    if (current) {
      opts[0] = current.option1;
      opts[1] = current.option2;
      opts[2] = current.option3;
    }
    opts[optionIdx] = value;
    /* Strict match (all options + available) */
    var match = g.variants.find(function (v) {
      return (opts[0] == null || v.option1 === opts[0]) &&
             (opts[1] == null || v.option2 === opts[1]) &&
             (opts[2] == null || v.option3 === opts[2]) &&
             v.available;
    });
    if (match) return match;
    /* Relaxed: just match the target option, take first available */
    return g.variants.find(function (v) {
      return v['option' + (optionIdx + 1)] === value && v.available;
    }) || g.variants.find(function (v) {
      return v['option' + (optionIdx + 1)] === value;
    });
  }

  /* Extract numeric size key (e.g. "6 ฟุต (King)" → "6") */
  function extractSizeKey(s) {
    if (!s) return null;
    var m = String(s).match(/(\d+(?:\.\d+)?)\s*ฟุต/i);
    if (m) return m[1];
    var m2 = String(s).match(/(\d+(?:\.\d+)?)\s*(ft|feet|inch|"|in)/i);
    if (m2) return m2[1];
    return null;
  }

  /* ===== AUTO-LOCK GIFT SIZE TO PARENT =====
     If gift has a size option AND parent has a size option, auto-match.
     Customer cannot change the size — locked to parent's size. */
  function autoLockSizeOption(g, giftKey, instanceCount) {
    if (!g.let_customer_choose) return false;
    if (!g.options || g.has_only_default_variant) return false;

    /* Find parent's selected size value */
    var parentSize = getParentOptionValueByType('size');
    if (!parentSize) return false;
    var parentKey = extractSizeKey(parentSize) || parentSize;

    /* Find gift's size option */
    var sizeIdx = -1, sizeOpt = null;
    for (var i = 0; i < g.options.length; i++) {
      if (isSizeOption(g.options[i].name)) {
        sizeIdx = i;
        sizeOpt = g.options[i];
        break;
      }
    }
    if (sizeIdx === -1) return false;

    /* Find matching value in gift's size options */
    var matchValue = null;
    /* Try exact first */
    if (sizeOpt.values.indexOf(parentSize) !== -1) {
      matchValue = parentSize;
    } else {
      /* Match by extracted key (e.g. "6 ฟุต") */
      for (var v = 0; v < sizeOpt.values.length; v++) {
        var giftKey2 = extractSizeKey(sizeOpt.values[v]);
        if (giftKey2 && giftKey2 === parentKey) {
          matchValue = sizeOpt.values[v];
          break;
        }
      }
    }
    if (!matchValue) return false;

    /* Lock all instances to this size */
    var arr = customerGiftSelections[giftKey] || [];
    var changed = false;
    for (var ii = 0; ii < instanceCount; ii++) {
      var currentVid = arr[ii];
      var currentVariant = currentVid ? g.variants.find(function (vv) { return String(vv.id) === String(currentVid); }) : null;
      /* Skip if already correctly locked */
      if (currentVariant && currentVariant['option' + (sizeIdx + 1)] === matchValue) continue;
      var matched = findGiftVariantWithOption(g, currentVid, sizeIdx, matchValue);
      if (matched) {
        arr[ii] = matched.id;
        changed = true;
      }
    }
    if (changed) {
      customerGiftSelections[giftKey] = arr;
      saveSelections();
    }
    return true; /* size IS locked (whether changed or not) */
  }

  /* ===== AUTO-SELECT SINGLE-VALUE OPTIONS =====
     If a gift option has only 1 value, auto-pick it (no need to ask). */
  function autoSelectSingleValueOptions(g, giftKey, instanceCount) {
    if (!g.let_customer_choose) return;
    if (!g.options || g.has_only_default_variant) return;
    var arr = customerGiftSelections[giftKey] || [];
    var changed = false;
    for (var oi = 0; oi < g.options.length; oi++) {
      var opt = g.options[oi];
      if (!opt.values || opt.values.length !== 1) continue;
      var val = opt.values[0];
      for (var ii = 0; ii < instanceCount; ii++) {
        var cur = arr[ii];
        var curV = cur ? g.variants.find(function (vv) { return String(vv.id) === String(cur); }) : null;
        if (curV && curV['option' + (oi + 1)] === val) continue;
        var matched = findGiftVariantWithOption(g, cur, oi, val);
        if (matched) {
          arr[ii] = matched.id;
          changed = true;
        }
      }
    }
    if (changed) {
      customerGiftSelections[giftKey] = arr;
      saveSelections();
    }
  }

  /* Returns array of option indices that are "locked" (auto-selected, no UI) */
  function getLockedOptionIndices(g) {
    var locked = [];
    if (!g.options) return locked;
    var hasParentSize = getParentOptionValueByType('size') != null;
    for (var oi = 0; oi < g.options.length; oi++) {
      var opt = g.options[oi];
      var single = opt.values && opt.values.length <= 1;
      var sizeLocked = hasParentSize && isSizeOption(opt.name);
      if (single || sizeLocked) locked.push(oi);
    }
    return locked;
  }

  function renderVariantPicker(gift, giftKey, cfg, instanceIdx) {
    if (!gift.options || gift.options.length === 0 || gift.has_only_default_variant) return '';
    instanceIdx = parseInt(instanceIdx, 10) || 0;
    var savedVid = (customerGiftSelections[giftKey] || [])[instanceIdx];
    var preselected = getPreselectedOptions(gift, savedVid);
    var loc = getLocale();
    var lockedIndices = getLockedOptionIndices(gift);
    var html = '<div class="sh-gift-card__picker" data-gift-key="' + escapeHtml(giftKey) + '" data-instance="' + instanceIdx + '">';

    /* Show "Locked" info pill at top — auto-matched options (size from parent, single-value) */
    if (lockedIndices.length > 0) {
      var lockedLines = [];
      lockedIndices.forEach(function (li) {
        var opt = gift.options[li];
        var val = preselected[li];
        if (val) {
          var icon = isSizeOption(opt.name) ? '🔗' : '✓';
          lockedLines.push(icon + ' ' + escapeHtml(opt.name) + ': <strong>' + escapeHtml(val) + '</strong>');
        }
      });
      if (lockedLines.length > 0) {
        var hint = (lockedIndices.some(function (i) { return isSizeOption(gift.options[i].name); }))
          ? (loc === 'en' ? 'matches your selection' : 'ตรงตามที่คุณเลือก')
          : (loc === 'en' ? 'auto-selected' : 'เลือกอัตโนมัติ');
        html += '<div class="sh-gift-card__locked-info">';
        html += '<span class="sh-gift-card__locked-text">' + lockedLines.join(' &nbsp;·&nbsp; ') + '</span>';
        html += '<span class="sh-gift-card__locked-hint">' + escapeHtml(hint) + '</span>';
        html += '</div>';
      }
    }

    var renderedAnyPicker = false;
    for (var oi = 0; oi < gift.options.length; oi++) {
      /* Skip locked options (size auto-matched to parent OR single-value) */
      if (lockedIndices.indexOf(oi) !== -1) continue;
      var opt = gift.options[oi];
      var optName = opt.name || ('Option ' + (oi+1));
      var labelKey = 'choose_option';
      if (isSizeOption(optName)) labelKey = 'choose_size';
      else if (isColorOption(optName)) labelKey = 'choose_color';
      var labelText = L(cfg, labelKey) || optName;
      var preVal = preselected[oi];
      renderedAnyPicker = true;

      /* COLOR → render swatches */
      if (isColorOption(optName) && opt.values.length <= 12) {
        html += '<div class="sh-gift-card__picker-row sh-gift-card__picker-row--color">';
        html += '<label class="sh-gift-card__picker-label">' + escapeHtml(labelText) + '</label>';
        html += '<div class="sh-gift-card__swatches">';
        for (var vi = 0; vi < opt.values.length; vi++) {
          var val = opt.values[vi];
          var isSel = preVal != null && val === preVal;
          var hex = getSwatchColor(val) || '#E5E7EB';
          var isLight = /white|ขาว|ครีม|cream|beige|yellow|เหลือง/i.test(val);
          html += '<button type="button" class="sh-gift-card__swatch' + (isSel ? ' is-selected' : '') + (isLight ? ' is-light' : '') + '"';
          html += ' data-option-index="' + oi + '" data-option-value="' + escapeHtml(val) + '"';
          html += ' aria-label="' + escapeHtml(val) + '"';
          html += ' style="--swatch-color: ' + hex + ';">';
          html += '<span class="sh-gift-card__swatch-check"><svg width="10" height="8" viewBox="0 0 10 8" fill="none"><path d="M1 4l2.5 2.5L9 1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
          html += '<span class="sh-gift-card__swatch-label">' + escapeHtml(val) + '</span>';
          html += '</button>';
        }
        /* Hidden select to keep existing handlePickerChange logic working */
        html += '<select class="sh-gift-card__picker-select sh-gift-card__picker-select--hidden" data-option-index="' + oi + '" aria-hidden="true" tabindex="-1">';
        html += '<option value=""' + (preVal == null ? ' selected' : '') + '></option>';
        for (var vi2 = 0; vi2 < opt.values.length; vi2++) {
          var val2 = opt.values[vi2];
          var sel2 = (preVal != null && val2 === preVal) ? ' selected' : '';
          html += '<option value="' + escapeHtml(val2) + '"' + sel2 + '>' + escapeHtml(val2) + '</option>';
        }
        html += '</select>';
        html += '</div>';
        html += '</div>';
        continue;
      }

      /* SIZE → render pill buttons */
      if (isSizeOption(optName) && opt.values.length <= 8) {
        html += '<div class="sh-gift-card__picker-row sh-gift-card__picker-row--size">';
        html += '<label class="sh-gift-card__picker-label">' + escapeHtml(labelText) + '</label>';
        html += '<div class="sh-gift-card__size-pills">';
        for (var si = 0; si < opt.values.length; si++) {
          var sval = opt.values[si];
          var sSel = preVal != null && sval === preVal;
          html += '<button type="button" class="sh-gift-card__size-pill' + (sSel ? ' is-selected' : '') + '"';
          html += ' data-option-index="' + oi + '" data-option-value="' + escapeHtml(sval) + '">';
          html += escapeHtml(sval);
          html += '</button>';
        }
        /* Hidden select for state sync */
        html += '<select class="sh-gift-card__picker-select sh-gift-card__picker-select--hidden" data-option-index="' + oi + '" aria-hidden="true" tabindex="-1">';
        html += '<option value=""' + (preVal == null ? ' selected' : '') + '></option>';
        for (var si2 = 0; si2 < opt.values.length; si2++) {
          var sval2 = opt.values[si2];
          var sSel2 = (preVal != null && sval2 === preVal) ? ' selected' : '';
          html += '<option value="' + escapeHtml(sval2) + '"' + sSel2 + '>' + escapeHtml(sval2) + '</option>';
        }
        html += '</select>';
        html += '</div>';
        html += '</div>';
        continue;
      }

      /* DEFAULT → dropdown (many options or unknown type) */
      html += '<div class="sh-gift-card__picker-row">';
      html += '<label class="sh-gift-card__picker-label">' + escapeHtml(labelText) + '</label>';
      html += '<select class="sh-gift-card__picker-select" data-option-index="' + oi + '">';
      html += '<option value=""' + (preVal == null ? ' selected' : '') + '>' + escapeHtml('— ' + labelText + ' —') + '</option>';
      for (var vi3 = 0; vi3 < opt.values.length; vi3++) {
        var val3 = opt.values[vi3];
        var sel3 = (preVal != null && val3 === preVal) ? ' selected' : '';
        html += '<option value="' + escapeHtml(val3) + '"' + sel3 + '>' + escapeHtml(val3) + '</option>';
      }
      html += '</select>';
      html += '</div>';
    }
    /* Status line — only show if there's an actual picker (not all locked) */
    if (renderedAnyPicker) {
      var statusTxt = L(cfg, 'please_select') || 'กรุณาเลือก';
      var statusType = 'pending';
      if (savedVid && gift.variants) {
        var v = gift.variants.find(function (x) { return String(x.id) === String(savedVid); });
        if (v && v.available) { statusTxt = '✓ ' + v.title; statusType = 'ok'; }
      }
      html += '<div class="sh-gift-card__picker-status" data-status="' + statusType + '">' + escapeHtml(statusTxt) + '</div>';
    }
    html += '</div>';
    return html;
  }

  /* Render the COMPLETE picker block for one gift definition.
     Handles single-instance OR multi-instance with same-for-all toggle. */
  function renderGiftInstancePickers(gift, giftKey, cfg, instanceCount) {
    if (gift.has_only_default_variant || !gift.options || gift.options.length === 0) return '';
    if (instanceCount <= 1) {
      return renderVariantPicker(gift, giftKey, cfg, 0);
    }
    var loc = getLocale();
    var sameForAll = giftSameForAll[giftKey] !== false; /* default true */
    var html = '<div class="sh-gift-card__multi" data-gift-key="' + escapeHtml(giftKey) + '" data-count="' + instanceCount + '">';

    /* "Same for all" toggle */
    var sameLabelTh = 'เลือกเหมือนกันทุกชิ้น (' + instanceCount + ' ชิ้น)';
    var sameLabelEn = 'Same option for all ' + instanceCount + ' gifts';
    var diffLabelTh = 'เลือกแยกแต่ละชิ้น';
    var diffLabelEn = 'Choose separately';
    html += '<label class="sh-gift-card__same-toggle">';
    html += '<input type="checkbox" data-same-for-all' + (sameForAll ? ' checked' : '') + '>';
    html += '<span class="sh-gift-card__same-toggle-text">' + escapeHtml(loc === 'en' ? sameLabelEn : sameLabelTh) + '</span>';
    html += '</label>';

    if (sameForAll) {
      /* One picker → applies to all */
      html += renderVariantPicker(gift, giftKey, cfg, 0);
      var noteTh = '✦ ตัวเลือกนี้จะใช้กับของแถมทั้ง ' + instanceCount + ' ชิ้น';
      var noteEn = '✦ This selection will apply to all ' + instanceCount + ' gifts';
      html += '<div class="sh-gift-card__multi-note">' + escapeHtml(loc === 'en' ? noteEn : noteTh) + '</div>';
    } else {
      /* N pickers, one per instance */
      for (var i = 0; i < instanceCount; i++) {
        html += '<div class="sh-gift-card__instance">';
        html += '<div class="sh-gift-card__instance-header">';
        html += '<span class="sh-gift-card__instance-num">' + escapeHtml(loc === 'en' ? 'Gift #' : 'ชิ้นที่ ') + (i + 1) + '</span>';
        if (i > 0) {
          var copyTh = '⎘ คัดลอกจากชิ้น #1';
          var copyEn = '⎘ Copy from #1';
          html += '<button type="button" class="sh-gift-card__copy-btn" data-copy-target="' + i + '">' + escapeHtml(loc === 'en' ? copyEn : copyTh) + '</button>';
        }
        html += '</div>';
        html += renderVariantPicker(gift, giftKey, cfg, i);
        html += '</div>';
      }
    }
    html += '</div>';
    return html;
  }

  /* Build display string showing all selected variants for a gift.
     "White × 2" if same for all, "White, Yellow, Blue" if different */
  function buildVariantSummary(gift, giftKey, instanceCount, loc) {
    var hasVariants = !gift.has_only_default_variant && gift.variants && gift.variants.length > 0;
    if (!hasVariants) return '';

    var ids = getGiftVariantIds(gift, giftKey, instanceCount);
    var titles = ids.map(function (id) {
      if (!id) return null;
      var v = gift.variants.find(function (x) { return String(x.id) === String(id); });
      return v ? v.title : null;
    });
    var allSet = titles.every(function (t) { return t != null; });
    if (!allSet) {
      var unset = titles.filter(function (t) { return t == null; }).length;
      if (loc === 'en') return '⚠ Please choose ' + unset + ' option' + (unset > 1 ? 's' : '') + ' below';
      return '⚠ กรุณาเลือก ' + unset + ' ตัวเลือกด้านล่าง';
    }
    /* All selected — group counts */
    var counts = {};
    titles.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });
    var keys = Object.keys(counts);
    if (keys.length === 1) {
      return instanceCount > 1 ? (keys[0] + ' × ' + instanceCount) : keys[0];
    }
    return keys.map(function (t) { return t + (counts[t] > 1 ? ' ×' + counts[t] : ''); }).join(', ');
  }

  function renderGiftCard() {
    var cfg = loadConfig();
    if (!cfg) return;
    if (!isProductTargeted(cfg)) return;
    var mount = findGiftMount();
    if (!mount) return;

    var vid = getCurrentVariantId();
    var parentQty = getParentQuantity();
    var rules = getApplicableRules(vid, { includeThreshold: false });

    if (rules.length === 0) { mount.innerHTML = ''; mount.__rules = []; return; }
    mount.__rules = rules;
    mount.__parentQty = parentQty;

    var loc = getLocale();
    var titleTxt = L(cfg, 'title');
    var valueLabel = L(cfg, 'value');
    var showValue = !cfg.behavior || cfg.behavior.show_value !== false;
    var showImage = !cfg.behavior || cfg.behavior.show_image !== false;

    /* Helper: compute gift value in BAHT (Liquid outputs prices in CENTS).
       g.value comes from {{ variant.compare_at_price | default: variant.price }}
       which is an integer in cents (e.g. 79000 = ฿790).
       Per-instance variant choice gets actual variant price (also cents).
       FIX: divide by 100 consistently — was missing for g.value. */
    function computeGiftValue(g, giftKey, instanceCount) {
      /* If customer can choose, sum prices of EACH selected instance variant */
      if (g.let_customer_choose && g.variants && giftKey) {
        var ids = getGiftVariantIds(g, giftKey, instanceCount);
        var sum = 0;
        ids.forEach(function (id) {
          if (!id) return;
          var v = g.variants.find(function (x) { return String(x.id) === String(id); });
          if (v) sum += (v.compare_at_price || v.price || 0);
        });
        if (sum > 0) return Math.round(sum / 100);
      }
      /* Otherwise use admin-set value (in cents) × instances */
      if (g.value) return Math.round((g.value * instanceCount) / 100);
      /* Fallback: first variant compare_at_price or price */
      if (g.variants && g.variants.length > 0) {
        var v0 = g.variants[0];
        var cents = v0.compare_at_price || v0.price || 0;
        if (cents > 0) return Math.round(cents / 100) * instanceCount;
      }
      return 0;
    }

    /* Auto-lock & auto-select BEFORE compute (so prices reflect locked variants) */
    rules.forEach(function (r, ri) {
      (r.gifts || []).forEach(function (g, gi) {
        var key = (r.id || 'rule') + '__' + gi + '__' + g.product_id;
        var cnt = getGiftInstanceCount(g, parentQty);
        autoLockSizeOption(g, key, cnt);
        autoSelectSingleValueOptions(g, key, cnt);
      });
    });

    /* Pre-compute total gift count + total value for hero display */
    var preTotalValue = 0;
    var preTotalCount = 0;
    rules.forEach(function (r, ri) {
      (r.gifts || []).forEach(function (g, gi) {
        var key = (r.id || 'rule') + '__' + gi + '__' + g.product_id;
        var cnt = getGiftInstanceCount(g, parentQty);
        preTotalCount += cnt;
        preTotalValue += computeGiftValue(g, key, cnt);
      });
    });

    var html = '<div class="sh-gift-card">';
    /* Red bookmark ribbon — sticks out top-right (clean, happy tone) */
    html += '<div class="sh-gift-card__stamp">';
    html += '<span>' + escapeHtml(loc === 'en' ? 'FREE' : 'แถมฟรี') + '</span>';
    html += '</div>';

    /* Optional hero value — ONLY if computable. No redundant title/subtitle text. */
    if (showValue && preTotalValue > 0) {
      html += '<div class="sh-gift-card__hero-strip">';
      html += '<span class="sh-gift-card__hero-label">' + escapeHtml(loc === 'en' ? 'Total value' : 'มูลค่ารวม') + '</span>';
      html += '<span class="sh-gift-card__hero-amount">฿' + preTotalValue.toLocaleString() + '</span>';
      html += '<span class="sh-gift-card__hero-saved">' + escapeHtml(loc === 'en' ? 'Save 100%' : 'ประหยัด 100%') + '</span>';
      html += '</div>';
    }

    var totalValue = 0;
    html += '<div class="sh-gift-card__rules">';
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      /* Suppress redundant rule label since we already say "ของแถมฟรี" in header */
      html += '<div class="sh-gift-card__rule">';
      html += '<ul class="sh-gift-card__list">';
      var gifts = rule.gifts || [];
      for (var j = 0; j < gifts.length; j++) {
        var g = gifts[j];
        var giftKey = (rule.id || 'rule') + '__' + j + '__' + g.product_id;
        var gLabel = loc === 'en' ? (g.label_en || g.label_th || g.title || g.handle) : (g.label_th || g.label_en || g.title || g.handle);
        var instanceCount = getGiftInstanceCount(g, parentQty);
        var giftValue = computeGiftValue(g, giftKey, instanceCount);
        totalValue += giftValue;

        /* Build variant summary across all instances */
        var variantInfo = buildVariantSummary(g, giftKey, instanceCount, loc);

        /* Determine if picker should render — hide if all options have only 1 value */
        var hasMultiOptions = g.options && g.options.some(function (o) { return o.values && o.values.length > 1; });
        var shouldRenderPicker = g.let_customer_choose && !g.has_only_default_variant && hasMultiOptions;

        html += '<li class="sh-gift-card__item" data-gift-key="' + escapeHtml(giftKey) + '" data-instances="' + instanceCount + '">';
        html += '<div class="sh-gift-card__item-row">';
        if (showImage && g.image) {
          html += '<div class="sh-gift-card__item-img-wrap">';
          html += '<img class="sh-gift-card__item-img" src="' + escapeHtml(g.image) + '" alt="" loading="lazy" width="96" height="96">';
          if (instanceCount > 1) {
            html += '<span class="sh-gift-card__item-count-badge">×' + instanceCount + '</span>';
          }
          html += '</div>';
        } else {
          html += '<span class="sh-gift-card__check">✓</span>';
        }
        html += '<div class="sh-gift-card__item-info">';
        html += '<span class="sh-gift-card__item-label">' + escapeHtml(gLabel) + '</span>';
        /* Price row: strikethrough + FREE */
        html += '<div class="sh-gift-card__item-price-row">';
        if (giftValue > 0) {
          html += '<span class="sh-gift-card__item-price-original">฿' + giftValue.toLocaleString() + '</span>';
        }
        html += '<span class="sh-gift-card__item-price-free">' + escapeHtml(loc === 'en' ? 'FREE' : 'ฟรี') + '</span>';
        html += '</div>';
        /* Variant pill — only show if multi-options OR there's actual variant info */
        if (variantInfo && hasMultiOptions) {
          html += '<span class="sh-gift-card__item-variant" data-variant-display="' + escapeHtml(giftKey) + '">' + escapeHtml(variantInfo) + '</span>';
        }
        html += '</div>';
        html += '</div>';
        /* Picker only if customer can actually choose */
        if (shouldRenderPicker) {
          html += renderGiftInstancePickers(g, giftKey, cfg, instanceCount);
        }
        html += '</li>';
      }
      html += '</ul></div>';
    }
    html += '</div>';
    html += '</div>';

    mount.innerHTML = html;
    wireGiftCardEvents(mount);
  }

  /* Wire all interactive elements: pickers, same-for-all toggles, copy buttons */
  function wireGiftCardEvents(mount) {
    /* Variant picker change → update selection at instance idx */
    mount.querySelectorAll('.sh-gift-card__picker').forEach(function (pickerEl) {
      var giftKey = pickerEl.getAttribute('data-gift-key');
      var instanceIdx = parseInt(pickerEl.getAttribute('data-instance'), 10) || 0;
      pickerEl.addEventListener('change', function (e) {
        if (e.target.matches('select[data-option-index]')) {
          handlePickerChange(pickerEl, giftKey, instanceIdx);
        }
      });
      /* Swatch + size-pill clicks — sync to hidden select + fire change */
      pickerEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.sh-gift-card__swatch, .sh-gift-card__size-pill');
        if (!btn) return;
        e.preventDefault();
        var optIdx = btn.getAttribute('data-option-index');
        var optVal = btn.getAttribute('data-option-value');
        /* Toggle selected state on all siblings of same option */
        pickerEl.querySelectorAll('[data-option-index="' + optIdx + '"]').forEach(function (el) {
          if (el.tagName === 'BUTTON') el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        /* Sync to hidden select */
        var hiddenSel = pickerEl.querySelector('select[data-option-index="' + optIdx + '"]');
        if (hiddenSel) {
          hiddenSel.value = optVal;
          hiddenSel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    /* Same-for-all toggle */
    mount.querySelectorAll('.sh-gift-card__same-toggle input[data-same-for-all]').forEach(function (chk) {
      chk.addEventListener('change', function () {
        var multi = chk.closest('.sh-gift-card__multi');
        var giftKey = multi.getAttribute('data-gift-key');
        giftSameForAll[giftKey] = !!chk.checked;
        /* If switching to "different", pre-fill all instances with current [0] for convenience */
        if (!chk.checked) {
          var arr = customerGiftSelections[giftKey] || [];
          var first = arr[0];
          var count = parseInt(multi.getAttribute('data-count'), 10) || 1;
          if (first) {
            for (var k = 1; k < count; k++) {
              if (arr[k] == null) arr[k] = first;
            }
            customerGiftSelections[giftKey] = arr;
          }
        }
        saveSelections();
        renderGiftCard();
      });
    });
    /* Copy from #1 button */
    mount.querySelectorAll('.sh-gift-card__copy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var multi = btn.closest('.sh-gift-card__multi');
        var giftKey = multi.getAttribute('data-gift-key');
        var targetIdx = parseInt(btn.getAttribute('data-copy-target'), 10);
        var arr = customerGiftSelections[giftKey] || [];
        if (arr[0] != null) {
          arr[targetIdx] = arr[0];
          customerGiftSelections[giftKey] = arr;
          saveSelections();
          renderGiftCard();
          showToast(getLocale() === 'en' ? '✓ Copied from Gift #1' : '✓ คัดลอกจากชิ้นที่ 1 แล้ว');
        }
      });
    });
  }

  /* ===== HANDLE CUSTOMER PICK ===== */
  function handlePickerChange(pickerEl, giftKey, instanceIdx) {
    instanceIdx = parseInt(instanceIdx, 10) || 0;
    var selects = pickerEl.querySelectorAll('select[data-option-index]');
    var values = [];
    var allFilled = true;
    selects.forEach(function(s){
      values.push(s.value || null);
      if (!s.value) allFilled = false;
    });
    var statusEl = pickerEl.querySelector('.sh-gift-card__picker-status');
    var arr = customerGiftSelections[giftKey] || [];

    if (!allFilled) {
      arr[instanceIdx] = null;
      customerGiftSelections[giftKey] = arr;
      if (statusEl) {
        statusEl.setAttribute('data-status', 'pending');
        statusEl.textContent = L(loadConfig(), 'please_select') || 'กรุณาเลือก';
      }
      saveSelections();
      updateVariantDisplay(giftKey);
      return;
    }
    /* Find gift definition */
    var rules = (findGiftMount() || {}).__rules || [];
    var gift = null;
    for (var i = 0; i < rules.length; i++) {
      var gs = rules[i].gifts || [];
      for (var j = 0; j < gs.length; j++) {
        var key = (rules[i].id || 'rule') + '__' + j + '__' + gs[j].product_id;
        if (key === giftKey) { gift = gs[j]; break; }
      }
      if (gift) break;
    }
    if (!gift) return;
    var variant = findVariantByOptions(gift, values[0], values[1], values[2]);

    if (variant && variant.available) {
      arr[instanceIdx] = variant.id;
      customerGiftSelections[giftKey] = arr;
      if (statusEl) {
        statusEl.setAttribute('data-status', 'ok');
        statusEl.textContent = '✓ ' + variant.title;
      }
    } else {
      arr[instanceIdx] = null;
      customerGiftSelections[giftKey] = arr;
      if (statusEl) {
        statusEl.setAttribute('data-status', 'unavailable');
        statusEl.textContent = getLocale() === 'en' ? 'Out of stock' : 'หมดสต็อก';
      }
    }
    saveSelections();
    updateVariantDisplay(giftKey);
  }

  /* Update the variant summary line above the picker after a selection change */
  function updateVariantDisplay(giftKey) {
    var mount = findGiftMount();
    if (!mount) return;
    var rules = mount.__rules || [];
    var parentQty = mount.__parentQty || getParentQuantity();
    var loc = getLocale();
    for (var i = 0; i < rules.length; i++) {
      var gs = rules[i].gifts || [];
      for (var j = 0; j < gs.length; j++) {
        var key = (rules[i].id || 'rule') + '__' + j + '__' + gs[j].product_id;
        if (key !== giftKey) continue;
        var g = gs[j];
        var instanceCount = getGiftInstanceCount(g, parentQty);
        var summary = buildVariantSummary(g, giftKey, instanceCount, loc);
        var displayEl = mount.querySelector('[data-variant-display="' + giftKey + '"]');
        if (displayEl) {
          displayEl.textContent = summary;
          /* Determine state: any null = pending, all set = ok */
          var ids = getGiftVariantIds(g, giftKey, instanceCount);
          var allSet = ids.every(function (x) { return x != null; });
          displayEl.setAttribute('data-state', allSet ? 'ok' : 'pending');
        }
        return;
      }
    }
  }

  /* ===== VARIANT + QTY CHANGE LISTENER (main product) ===== */
  var lastParentQty = 0;
  var lastParentVid = '';
  function checkAndRender() {
    var q = getParentQuantity();
    var v = getCurrentVariantId() || '';
    if (q !== lastParentQty || v !== lastParentVid) {
      var changed = [];
      if (q !== lastParentQty) changed.push('qty:' + q);
      if (v !== lastParentVid) changed.push('vid:' + v);
      lastParentQty = q;
      lastParentVid = v;
      _shLog('[SH Promo] parent change →', changed.join(', '));
      renderGiftCard();
    }
  }
  function setupVariantListener() {
    /* Re-render on variant change AND qty change.
       Halo's variant picker uses <hdt-variant-picker> with radio inputs that
       are NOT inside the form (form="..." attribute reference). We catch via
       the picker element itself. */
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      var t = e.target;
      /* Skip our own gift card pickers — they have their own handler */
      if (t.closest && t.closest('.sh-gift-card')) return;

      var insidePicker = t.closest && t.closest('hdt-variant-picker, [class*="variant-picker"], fieldset.hdt-product-form__input');
      var inForm = t.closest && t.closest('form[action*="/cart/add"]');
      var isQty = t.name === 'quantity' || (t.closest && t.closest('[data-quantity-input], hdt-quantity-input, hdt-quantity, .hdt-quantity'));

      if (insidePicker || inForm || isQty || t.name === 'id' || t.name === 'options' ||
          (t.closest && t.closest('[name*="option"]')) ||
          (t.type === 'radio' && t.name && /^[A-Za-zก-๙]/.test(t.name))) {
        /* Trigger render at multiple intervals to catch Halo's async variant ID update */
        setTimeout(checkAndRender, 50);
        setTimeout(checkAndRender, 200);
      }
    }, true);

    /* Also catch CLICKS on variant picker labels (radios update via click on label) */
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      var t = e.target;
      if (t.closest && t.closest('.sh-gift-card')) return;
      var pickerEl = t.closest && t.closest('hdt-variant-picker label, hdt-variant-picker .hdt-product-form_value, [class*="variant-picker"] label');
      if (pickerEl) {
        setTimeout(checkAndRender, 80);
        setTimeout(checkAndRender, 250);
      }
    }, true);
    /* Also listen to clicks on +/- qty buttons (Halo theme) */
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      var t = e.target;
      if (t.closest && t.closest('.sh-gift-card')) return;
      var qtyBtn = t.closest && t.closest('[data-quantity-input] button, hdt-quantity-input button, hdt-quantity button, .hdt-quantity__button, .hdt-quantity button, button[name="plus"], button[name="minus"], button[data-quantity-action]');
      if (qtyBtn) {
        setTimeout(checkAndRender, 60);
        setTimeout(checkAndRender, 200);
        setTimeout(checkAndRender, 500);
      }
    }, true);
    /* Input event for direct typing into qty field */
    document.addEventListener('input', function (e) {
      if (!e.target) return;
      var t = e.target;
      if (t.closest && t.closest('.sh-gift-card')) return;
      if (t.name === 'quantity' || (t.closest && t.closest('[data-quantity-input], hdt-quantity-input, hdt-quantity, .hdt-quantity'))) {
        setTimeout(checkAndRender, 60);
        setTimeout(checkAndRender, 250);
      }
    }, true);

    /* MutationObserver: watch the qty input(s) for value attribute change.
       Halo theme often updates value via JS without firing events. */
    function observeQtyInput() {
      var inputs = document.querySelectorAll(
        'input.hdt-quantity__input, input[name="quantity"], hdt-quantity-input input, hdt-quantity input, [data-quantity-input] input'
      );
      inputs.forEach(function (inp) {
        if (inp.__shObserved) return;
        inp.__shObserved = true;
        try {
          var mo = new MutationObserver(function () { checkAndRender(); });
          mo.observe(inp, { attributes: true, attributeFilter: ['value'] });
        } catch (e) {}
        /* Also wrap the value setter to catch JS-driven changes */
        try {
          var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
          if (desc && desc.set && !inp.__shValueWrapped) {
            inp.__shValueWrapped = true;
            Object.defineProperty(inp, 'value', {
              configurable: true,
              get: function () { return desc.get.call(this); },
              set: function (v) {
                desc.set.call(this, v);
                setTimeout(checkAndRender, 30);
              }
            });
          }
        } catch (e) {}
      });
    }
    observeQtyInput();
    /* Re-observe periodically to catch dynamically added inputs (quick view modal etc) */
    setInterval(observeQtyInput, 1500);

    /* Polling safety net — check every 350ms (covers Halo theme custom UI) */
    setInterval(checkAndRender, 350);
    /* Initial seed — set lastParentQty so polling triggers re-render if it differs */
    setTimeout(checkAndRender, 100);
    setTimeout(checkAndRender, 600);
    setTimeout(checkAndRender, 1200);

    document.addEventListener('variant:change', renderGiftCard);
    document.addEventListener('product:variant-change', renderGiftCard);
    setTimeout(renderGiftCard, 200);
    setTimeout(renderGiftCard, 800);
    setTimeout(renderGiftCard, 1500);
  }

  /* ===== AUTO-ADD GIFTS ===== */
  var giftAddInProgress = false;
  function autoAddGifts(parentVariantId, parentQty) {
    parentQty = parseInt(parentQty, 10) || 1;
    _shLog('[SH Promo] 🎁 autoAddGifts called — parent:', parentVariantId, 'qty:', parentQty);
    var cfg = loadConfig();
    if (!cfg || !cfg.behavior || cfg.behavior.auto_add === false) {
      _shLog('[SH Promo] ❌ skipped: cfg missing or auto_add=false');
      return Promise.resolve();
    }
    if (!isProductTargeted(cfg)) {
      _shLog('[SH Promo] ❌ skipped: product not targeted');
      return Promise.resolve();
    }
    var rules = getApplicableRules(parentVariantId, { includeThreshold: false });
    if (rules.length === 0) {
      _shLog('[SH Promo] ❌ skipped: no applicable rules');
      return Promise.resolve();
    }
    _shLog('[SH Promo] ✓ rules found:', rules.length, 'selections:', JSON.stringify(customerGiftSelections));

    /* Build per-instance gift items.
       Each gift definition expands to N instances (parentQty × g.qty).
       Each instance becomes a separate cart line with quantity:1 (so we can
       have different variants per instance). */
    var allGifts = [];
    var pendingChoice = false;
    var pendingNeed = 0;
    rules.forEach(function (r) {
      (r.gifts || []).forEach(function (g, j) {
        var key = (r.id || 'rule') + '__' + j + '__' + g.product_id;
        var instanceCount = getGiftInstanceCount(g, parentQty);
        var ids = getGiftVariantIds(g, key, instanceCount);
        var perUnit = parseInt(g.qty, 10) || 1;
        var scale = g.scale_with_parent !== false;
        for (var ii = 0; ii < instanceCount; ii++) {
          var vid = ids[ii];
          if (!vid) {
            /* Customer hasn't selected for this instance */
            if (g.let_customer_choose) {
              pendingChoice = true;
              pendingNeed++;
            }
            continue;
          }
          allGifts.push({
            variant_id: vid,
            qty: 1, /* one line per instance */
            per_unit: perUnit,
            scale: scale,
            instance_idx: ii,
            gift_key: key,
            product_id: g.product_id,
            label_th: g.label_th, label_en: g.label_en, title: g.title
          });
        }
      });
    });

    if (pendingChoice) {
      var msg = pendingNeed > 1
        ? (getLocale() === 'en' ? 'Please select ' + pendingNeed + ' gift options first' : 'กรุณาเลือกตัวเลือกของแถม ' + pendingNeed + ' ชิ้นก่อน')
        : (L(cfg, 'please_select') || 'กรุณาเลือกตัวเลือกของแถมก่อน');
      console.warn('[SH Promo] ⚠ pending choice — need', pendingNeed, 'more selections');
      showToast(msg);
      return Promise.resolve();
    }
    if (allGifts.length === 0) {
      _shLog('[SH Promo] ❌ no gifts to add');
      return Promise.resolve();
    }
    if (giftAddInProgress) {
      _shLog('[SH Promo] ❌ already in progress');
      return Promise.resolve();
    }
    giftAddInProgress = true;
    _shLog('[SH Promo] ✓ adding', allGifts.length, 'gift instances:', allGifts.map(function(g){return g.variant_id+'×'+g.qty;}).join(', '));

    var giftLabel = L(cfg, 'gift_label');
    var lockable = cfg.behavior && cfg.behavior.allow_remove === false;

    var items = allGifts.map(function (g) {
      return {
        id: g.variant_id,
        quantity: g.qty,
        properties: {
          '_gift': 'true',
          '_gift_parent': String(parentVariantId),
          '_gift_label': giftLabel,
          '_gift_locked': lockable ? 'true' : 'false',
          '_gift_per_unit': String(g.per_unit),
          '_gift_scale': g.scale ? 'true' : 'false',
          '_gift_product': String(g.product_id),
          '_gift_instance': String(g.instance_idx)
        }
      };
    });

    var t0 = Date.now();
    _shLog('[SH Promo] POST /cart/add for', items.length, 'gift items');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-SH-Promo': 'gift-add'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      _shLog('[SH Promo] /cart/add response:', r.status, '(' + (Date.now() - t0) + 'ms)');
      return r.json().catch(function () { return null; });
    }).then(function (data) {
      var added = data && data.items ? data.items.length : 0;
      _shLog('[SH Promo] ✓ gifts added:', added, 'items');
      if (data && data.status && data.status >= 400) {
        console.warn('[SH Promo] Shopify rejected gift add:', data.message || data.description, data);
        return;
      }

      /* OPTIMISTIC UI: inject the SERVER-CONFIRMED gift items into drawer
         IMMEDIATELY (don't wait for full section refresh).
         User sees gifts appear within ~50ms of server confirm. */
      if (data && data.items) {
        injectOptimisticGifts(data.items);
      }

      /* Toast */
      if (cfg.behavior && cfg.behavior.show_toast !== false) {
        showToast(L(cfg, 'added_toast'));
      }

      /* Background full refresh — replaces optimistic with proper Halo HTML */
      var refreshP = refreshCartDrawer();

      /* V5.7 SECURITY: auto-apply discount code REMOVED (code leak fix).
         Free-gift pricing now handled by Shopify Automatic Buy-X-Get-Y discount
         (server-enforced eligibility — no frontend code exposure). */

      return refreshP;
    }).then(function () {
      _shLog('[SH Promo] ✓ drawer refreshed (' + (Date.now() - t0) + 'ms total)');
    }).catch(function (e) {
      console.warn('[SH Promo] gift add failed', e);
    }).finally(function () {
      giftAddInProgress = false;
    });
  }

  /* ===== OPTIMISTIC GIFT INJECTION =====
     After server confirms gift add, inject Halo-style line item HTML into
     drawer IMMEDIATELY — user sees gifts within ~50ms instead of waiting
     for full section refresh (~300-500ms). Real refresh replaces silently. */
  function injectOptimisticGifts(serverItems) {
    if (!serverItems || !serverItems.length) return;
    /* V5.0.7: Skip on /cart page — Halo refreshes the table natively, our
       optimistic injection would clobber the table or appear in wrong place. */
    if (/^\/cart(\/|\?|$)/.test(location.pathname)) {
      _shLog('[SH Promo] /cart page — skipping optimistic gift injection');
      return;
    }
    /* Halo line item container — SCOPED to drawer to avoid hitting cart page */
    var scrollWrap = document.querySelector(
      'hdt-cart-drawer .hdt-mini-cart__sroll[data-hdt-scroll-me], ' +
      'hdt-cart-drawer [data-hdt-scroll-me], ' +
      'hdt-cart-drawer .hdt-mini-cart__main, ' +
      'hdt-cart-drawer cart-items-component, ' +
      '.hdt-mini-cart__sroll[data-hdt-scroll-me]'
    );
    if (!scrollWrap) {
      _shLog('[SH Promo] no cart drawer scroll wrap found');
      return;
    }
    /* Don't double-inject */
    removeOptimisticGifts();

    var container = document.createElement('div');
    container.setAttribute('data-sh-optimistic', '1');
    container.innerHTML = serverItems.map(buildOptimisticGiftHTML).join('');
    scrollWrap.appendChild(container);
    _shLog('[SH Promo] ✓ optimistic injected', serverItems.length, 'gift lines');
  }

  function buildOptimisticGiftHTML(item) {
    /* Server item shape: { product_title, variant_title, image, price, line_price } */
    var title = escapeHtml(item.product_title || item.title || '');
    var variantTitle = escapeHtml(item.variant_title || (item.options_with_values && item.options_with_values.map(function(o){return o.value;}).join(' / ')) || '');
    var imgUrl = item.image ? (item.image.indexOf('//') === 0 ? 'https:' + item.image : item.image) : '';
    var imgHtml = imgUrl
      ? '<img src="' + escapeHtml(imgUrl) + '" loading="lazy" alt="" width="80" height="80" style="width:100%;height:100%;object-fit:cover;">'
      : '<span class="hdt-mini-cart__img-placeholder"></span>';
    var origPrice = item.original_line_price || item.original_price || item.compare_at_price || item.price || 0;
    var origPriceFmt = origPrice ? '฿' + (origPrice / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }) : '';
    return ''
      + '<div class="hdt-mini-cart__item hdt-cart-item hdt-flex hdt-relative hdt-oh hdt-line-item sh-gift-line-item" data-locked="true" data-sh-optimistic="1">'
      +   '<div class="hdt-mini-cart__image">'
      +     '<div class="hdt-mini-cart__img hdt-block hdt-relative hdt-oh hdt-ratio" style="--aspect-ratioapt:1;">'
      +       imgHtml
      +     '</div>'
      +   '</div>'
      +   '<div class="hdt-mini-cart__info hdt-s-text hdt-relative hdt-oh">'
      +     '<span class="hdt-mini-cart__title hdt-truncate hdt-block hdt-s-text">' + title + '</span>'
      +     (variantTitle ? '<div class="hdt-mini-cart__meta-variant hdt-text-sm hdt-font-normal hdt-s-text2 hdt-block">' + variantTitle + '</div>' : '')
      +     '<div class="hdt-mini-cart__price">'
      +       (origPriceFmt ? '<span style="text-decoration:line-through;color:#8A8A8A;font-size:13px;margin-right:6px;">' + origPriceFmt + '</span>' : '')
      +       '<span style="color:#10B981;font-weight:500;">ฟรี</span>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }

  function removeOptimisticGifts() {
    document.querySelectorAll('[data-sh-optimistic]').forEach(function (el) {
      el.remove();
    });
  }

  /* ===== REFRESH CART PAGE =====
     V5.0.8: When on /cart page, refresh main-cart section (the table).
     This preserves table structure (vs. clobbering with drawer div HTML)
     while updating qty/totals/line items after sync changes.
     V5.0.9: Also fetch cart-icon-bubble so header count stays in sync. */
  function refreshCartPage() {
    return fetch('/?sections=main-cart,cart-icon-bubble', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (sections) {
        if (!sections) return;
        try {
          if (sections['main-cart']) {
            var newDoc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
            var newCart = newDoc.querySelector('hdt-main-cart');
            var oldCart = document.querySelector('hdt-main-cart');
            if (newCart && oldCart) {
              oldCart.innerHTML = newCart.innerHTML;
              _shLog('[SH Promo] ✓ /cart page refreshed via main-cart section');
              /* V5.0.9: Multi-stage rescan to catch slow renders + ensure
                 gift class application sticks. Debounced via scheduleScan. */
              setTimeout(function () { scheduleScan(0); }, 100);
              setTimeout(function () { scheduleScan(0); }, 500);
              setTimeout(function () { scheduleScan(0); }, 1500);
            }
          }
          /* V5.0.9: Update header cart count too */
          if (sections['cart-icon-bubble']) {
            var iconDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            ['hdt-cart-count', 'cart-icon-bubble', '[data-cart-count]', '.hdt-count-box'].forEach(function (sel) {
              var newCount = iconDoc.querySelector(sel);
              var oldCount = document.querySelector(sel);
              if (newCount && oldCount) {
                oldCount.innerHTML = newCount.innerHTML;
                if (newCount.hasAttribute('data-count')) {
                  oldCount.setAttribute('data-count', newCount.getAttribute('data-count'));
                }
              }
            });
          }
        } catch (e) { console.warn('[SH Promo] cart page refresh DOM error', e); }
        ['cart:refresh', 'cart:updated'].forEach(function (ev) {
          document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: {} }));
        });
      })
      .catch(function (e) { console.warn('[SH Promo] /cart page refresh failed', e); });
  }

  /* ===== REFRESH CART DRAWER =====
     CRITICAL: Halo wraps cart in <dialog>. Replacing the entire <hdt-cart-drawer>
     would destroy + recreate the dialog → dialog closes. Instead we ONLY swap
     the inner cart-items-component (the list of items + footer block).
     PERF: Fetch ONLY cart-drawer + cart-icon-bubble (skip full headers).
     V5.0.8: On /cart page, dispatch to refreshCartPage() instead of skipping. */
  function refreshCartDrawer() {
    var isCartPage = /^\/cart(\/|\?|$)/.test(location.pathname);
    /* V5.0.8: On /cart page, refresh the cart page table instead of drawer.
       Drawer still gets count update via cart-icon-bubble below. */
    if (isCartPage) {
      return refreshCartPage();
    }

    return fetch('/?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (sections) {
        if (!sections) return;
        try {
          /* V5.0.7: SCOPE selector to <hdt-cart-drawer> ONLY.
             Without this scope, on /cart page querySelector returns the
             cart page's cart-items-component first → catastrophic DOM swap.
             V5.0.8: /cart page short-circuits earlier via refreshCartPage(),
             so this block only runs on non-cart-page contexts. */
          if (sections['cart-drawer']) {
            var newDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var newCart = newDoc.querySelector('hdt-cart-drawer cart-items-component') ||
                          newDoc.querySelector('cart-items-component');
            var oldCart = document.querySelector('hdt-cart-drawer cart-items-component');
            if (newCart && oldCart) {
              oldCart.innerHTML = newCart.innerHTML;
              _shLog('[SH Promo] ✓ cart-items-component refreshed (dialog stays open)');
            } else if (!oldCart) {
              /* Drawer not yet present in DOM — fallback to swapping <hdt-cart-drawer> inner */
              var newDrawer = newDoc.querySelector('hdt-cart-drawer');
              var oldDrawer = document.querySelector('hdt-cart-drawer');
              if (newDrawer && oldDrawer) {
                oldDrawer.innerHTML = newDrawer.innerHTML;
                _shLog('[SH Promo] ✓ hdt-cart-drawer inner refreshed (fallback)');
              }
            }
            /* Update data-count attribute on hdt-cart-drawer */
            var newDrawerEl = newDoc.querySelector('hdt-cart-drawer');
            var oldDrawerEl = document.querySelector('hdt-cart-drawer');
            if (newDrawerEl && oldDrawerEl && newDrawerEl.hasAttribute('data-count')) {
              oldDrawerEl.setAttribute('data-count', newDrawerEl.getAttribute('data-count'));
            }
          }
          /* Refresh cart count bubble in header */
          ['cart-icon-bubble', 'header', 'header-mb', 'header-mobile'].forEach(function (sec) {
            if (!sections[sec]) return;
            var newSecDoc = new DOMParser().parseFromString(sections[sec], 'text/html');
            ['hdt-cart-count', 'cart-icon-bubble', '[data-cart-count]', '.hdt-count-box'].forEach(function (sel) {
              var newCount = newSecDoc.querySelector(sel);
              var oldCount = document.querySelector(sel);
              if (newCount && oldCount) {
                oldCount.innerHTML = newCount.innerHTML;
                if (newCount.hasAttribute('data-count')) {
                  oldCount.setAttribute('data-count', newCount.getAttribute('data-count'));
                }
              }
            });
          });
        } catch (e) { console.warn('[SH Promo] cart drawer refresh DOM error', e); }
        /* Dispatch all common cart events */
        ['cart:refresh', 'cart:updated', 'cart:added', 'theme:cart:added', 'theme:cart:updated', 'cart:item-added', 'on:cart:after-update'].forEach(function (ev) {
          document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: {} }));
        });
      })
      .catch(function (e) {
        console.warn('[SH Promo] section refresh failed', e);
      });
  }

  /* ===== SYNC GIFT QUANTITIES WITH PARENT =====
     เมื่อลูกค้าเปลี่ยนจำนวน parent ใน cart drawer → ปรับจำนวน gift ตาม
     อ่าน /cart.js → จับคู่ gift กับ parent ด้วย _gift_parent + _gift_per_unit
     แล้ว POST /cart/change.js เพื่อปรับ gift quantity ให้ตรง */
  var syncInProgress = false;
  function syncGiftQuantities() {
    if (syncInProgress) return Promise.resolve();
    syncInProgress = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return null;

        /* Build parent map: variant_id → qty (sum if multiple lines same variant) */
        var parentQtyMap = {};
        cart.items.forEach(function (it) {
          var props = it.properties || {};
          if (props._gift === 'true') return;
          var vid = String(it.variant_id || it.id);
          parentQtyMap[vid] = (parentQtyMap[vid] || 0) + (it.quantity || 0);
        });

        /* Group gift lines by (parent_variant + gift_product).
           Expected total quantity = parent_qty × per_unit.
           Mode A (legacy): one line, qty = expected → update qty.
           Mode B (instance): multiple lines qty:1 → add/remove lines. */
        var changes = []; /* { key, quantity } — quantity 0 = remove */
        var addsNeeded = []; /* { variant_id, parent, props } — to be added */

        /* Group by (parent + product) for instance-mode lines */
        var groups = {}; /* groupKey → [lineItems] */
        cart.items.forEach(function (it) {
          var props = it.properties || {};
          if (props._gift !== 'true') return;
          if (props._gift_scale === 'false') return; /* fixed qty gift, skip */
          var parent = props._gift_parent;
          var product = props._gift_product || '_';
          var groupKey = parent + '||' + product;
          if (!groups[groupKey]) groups[groupKey] = [];
          groups[groupKey].push(it);
        });

        Object.keys(groups).forEach(function (gk) {
          var lines = groups[gk];
          var first = lines[0];
          var props = first.properties || {};
          var parent = props._gift_parent;
          var perUnit = parseInt(props._gift_per_unit, 10) || 1;
          var pqty = parentQtyMap[String(parent)] || 0;
          var expectedTotal = pqty * perUnit;

          /* Detect mode: instance-mode if any line has _gift_instance prop */
          var isInstanceMode = lines.some(function (l) { return (l.properties || {})._gift_instance != null; });

          if (!isInstanceMode) {
            /* Legacy mode: single line carries total qty */
            if (expectedTotal <= 0) {
              changes.push({ key: first.key, quantity: 0 });
            } else if (first.quantity !== expectedTotal) {
              changes.push({ key: first.key, quantity: expectedTotal });
            }
            return;
          }

          /* Instance mode: each line is qty:1 → count lines */
          var actualCount = lines.reduce(function (s, l) { return s + (l.quantity || 0); }, 0);
          if (expectedTotal <= 0) {
            /* Parent removed → remove all gift lines */
            lines.forEach(function (l) { changes.push({ key: l.key, quantity: 0 }); });
          } else if (actualCount > expectedTotal) {
            /* Too many → remove from end (highest instance idx first) */
            var sorted = lines.slice().sort(function (a, b) {
              var ai = parseInt((a.properties || {})._gift_instance, 10) || 0;
              var bi = parseInt((b.properties || {})._gift_instance, 10) || 0;
              return bi - ai; /* descending — remove highest idx first */
            });
            var toRemove = actualCount - expectedTotal;
            for (var ri = 0; ri < sorted.length && toRemove > 0; ri++) {
              var line = sorted[ri];
              var lineQty = line.quantity || 0;
              if (lineQty <= toRemove) {
                changes.push({ key: line.key, quantity: 0 });
                toRemove -= lineQty;
              } else {
                changes.push({ key: line.key, quantity: lineQty - toRemove });
                toRemove = 0;
              }
            }
          } else if (actualCount < expectedTotal) {
            /* Too few → add more lines, copy variant from first existing line */
            var need = expectedTotal - actualCount;
            for (var ai2 = 0; ai2 < need; ai2++) {
              addsNeeded.push({
                variant_id: first.variant_id || first.id,
                properties: Object.assign({}, props, {
                  '_gift_instance': String((parseInt(props._gift_instance, 10) || 0) + actualCount + ai2)
                })
              });
            }
          }
        });

        var totalOps = changes.length + addsNeeded.length;
        if (totalOps === 0) {
          _shLog('[SH Promo] sync: no changes needed');
          return null;
        }
        _shLog('[SH Promo] 🔄 sync: removing/updating', changes.length, 'gift lines, adding', addsNeeded.length);
        changes.forEach(function (c) { _shLog('  → change line', c.key, 'to qty', c.quantity); });

        /* Apply changes sequentially via /cart/change.js with internal header */
        var chain = changes.reduce(function (c, ch) {
          return c.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-SH-Promo': 'gift-sync'
              },
              credentials: 'same-origin',
              body: JSON.stringify({ id: ch.key, quantity: ch.quantity })
            }).then(function (r) {
              _shLog('[SH Promo] gift-sync change result:', r.status, ch);
              return r;
            });
          });
        }, Promise.resolve());

        /* Then apply adds */
        if (addsNeeded.length > 0) {
          chain = chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-SH-Promo': 'gift-sync'
              },
              credentials: 'same-origin',
              body: JSON.stringify({
                items: addsNeeded.map(function (a) {
                  return { id: a.variant_id, quantity: 1, properties: a.properties };
                })
              })
            });
          });
        }

        /* CRITICAL: After server-side changes, refresh cart drawer DOM
           so user actually SEES the gift count update */
        return chain.then(function () {
          _shLog('[SH Promo] ✓ sync complete, refreshing drawer DOM');
          return refreshCartDrawer();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function (e) { console.warn('[SH Promo] sync failed', e); })
      .then(function () { syncInProgress = false; });
  }

  /* ===== APPLY DISCOUNT CODE ===== */
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    code = String(code).trim();
    if (!code) return Promise.resolve();
    _shLog('[SH Promo] Applying discount code:', code);

    /* Method: GET /discount/{code}?redirect=... — Shopify's official way to apply discount via URL.
       This sets the discount cookie. Subsequent /cart.js will show the discount. */
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      _shLog('[SH Promo] discount endpoint response:', r.status);
      return r.json().catch(function () { return null; });
    }).then(function (cart) {
      if (cart && cart.cart_level_discount_applications) {
        _shLog('[SH Promo] discount applications:', cart.cart_level_discount_applications);
      }
      if (cart && cart.total_discount !== undefined) {
        _shLog('[SH Promo] cart total_discount:', cart.total_discount);
      }
      /* Force refresh cart drawer + section */
      return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).catch(function () {});
    }).catch(function (e) {
      console.warn('[SH Promo] discount apply failed', e);
    });
  }

  /* ===== ATC HOOK =====
     Coexists with sh-installment-suite.js's fetch wrapper via __shPromoPatched flag.
     If both load, my hook runs in chain (no double-wrap, no infinite loop). */
  function setupATCHook() {
    if (window.fetch && window.fetch.__shPromoPatched) {
      _shLog('[SH Promo] fetch already patched by sh-promo, skipping double-wrap');
      return;
    }
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var url = args[0];
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';

      /* Hook /cart/add — wait for parent response, then fire gift add.
         RELIABILITY > raw speed (V4.9 parallel approach broke gift system). */
      if (urlStr.indexOf('/cart/add') !== -1) {
        var opts = args[1] || {};
        var body = opts.body;
        var isGiftAdd = false;
        var requestedQty = 1;

        try {
          if (typeof body === 'string') {
            isGiftAdd = body.indexOf('"_gift"') !== -1;
            try {
              var parsed = JSON.parse(body);
              if (parsed.quantity != null) requestedQty = parseInt(parsed.quantity, 10) || 1;
              else if (parsed.items && parsed.items[0] && parsed.items[0].quantity != null) {
                requestedQty = parseInt(parsed.items[0].quantity, 10) || 1;
              }
            } catch (e) {}
          } else if (body instanceof FormData) {
            var fq = body.get && body.get('quantity');
            if (fq) requestedQty = parseInt(fq, 10) || 1;
          }
        } catch (e) {}

        var p = origFetch.apply(this, args);
        if (!isGiftAdd) {
          /* Wait for parent response → trigger gift add (sequential, reliable) */
          p.then(function (r) {
            try {
              r.clone().json().then(function (data) {
                var vid = data.id || (data.items && data.items[0] && data.items[0].id);
                var actualQty = data.quantity || (data.items && data.items[0] && data.items[0].quantity) || requestedQty;
                _shLog('[SH Promo] parent ATC done, vid:', vid, 'qty:', actualQty);
                if (vid) {
                  /* Short delay so Halo's drawer-open logic queues first */
                  setTimeout(function () { autoAddGifts(vid, actualQty); }, 30);
                }
              }).catch(function (e) {
                console.warn('[SH Promo] failed to parse parent ATC response', e);
              });
            } catch (e) {
              console.warn('[SH Promo] parent ATC clone failed', e);
            }
          });
        }
        return p;
      }

      /* Hook /cart/change + /cart/update → re-sync gifts when parent qty changes */
      if (urlStr.indexOf('/cart/change') !== -1 || urlStr.indexOf('/cart/update') !== -1) {
        var p2 = origFetch.apply(this, args);
        /* Avoid recursive sync from our own /cart/change calls during sync */
        if (!syncInProgress) {
          p2.then(function () {
            setTimeout(syncGiftQuantities, 250);
          });
        }
        return p2;
      }

      return origFetch.apply(this, args);
    };

    /* Also hook XHR for older theme code */
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__shUrl = url || '';
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function (body) {
        var xhr = this;
        var u = xhr.__shUrl || '';
        if (u.indexOf('/cart/change') !== -1 || u.indexOf('/cart/update') !== -1) {
          xhr.addEventListener('load', function () {
            if (!syncInProgress) setTimeout(syncGiftQuantities, 250);
          });
        } else if (u.indexOf('/cart/add') !== -1) {
          var qty = 1;
          try {
            if (typeof body === 'string') {
              var pd = JSON.parse(body);
              if (pd.quantity != null) qty = parseInt(pd.quantity, 10) || 1;
              else if (pd.items && pd.items[0]) qty = parseInt(pd.items[0].quantity, 10) || 1;
            } else if (body instanceof FormData) {
              var fq2 = body.get && body.get('quantity');
              if (fq2) qty = parseInt(fq2, 10) || 1;
            }
          } catch (e) {}
          var isGift = (typeof body === 'string') && body.indexOf('"_gift"') !== -1;
          /* Wait for parent XHR response → fire gift add */
          if (!isGift) {
            xhr.addEventListener('load', function () {
              try {
                var data = JSON.parse(xhr.responseText);
                var vid = data.id || (data.items && data.items[0] && data.items[0].id);
                var aq = data.quantity || (data.items && data.items[0] && data.items[0].quantity) || qty;
                if (vid) setTimeout(function () { autoAddGifts(vid, aq); }, 30);
              } catch (e) {}
            });
          }
        }
        return origSend.apply(this, arguments);
      };
    }

    /* Mark as patched so subsequent sh-promo loads skip */
    window.fetch.__shPromoPatched = true;
  }

  /* ===== TOAST ===== */
  function showToast(msg) {
    if (!msg) return;
    var t = document.getElementById('sh-promo-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sh-promo-toast';
      t.className = 'sh-promo-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('sh-promo-toast--show'); });
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('sh-promo-toast--show'); }, 2800);
  }

  /* ===== CART DETECTION (KEY-BASED — SAFE) =====
     OLD approach (text scan) caused false positives. NEW approach:
     1. Fetch /cart.js → identify gift line keys
     2. Find DOM line items by data-index (Halo) or order in DOM
     3. Tag ONLY those specific elements
     This guarantees zero false positives. */
  var giftLineKeys = []; /* {key, index, gift_product, gift_instance} */

  function scanCartForGifts() {
    /* Step 1: fetch cart for authoritative gift line list */
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        giftLineKeys = [];
        cart.items.forEach(function (it, idx) {
          var props = it.properties || {};
          if (props._gift === 'true') {
            giftLineKeys.push({
              key: it.key,
              index: idx + 1, /* 1-based for data-index */
              variant_id: it.variant_id,
              gift_product: props._gift_product,
              gift_instance: props._gift_instance,
              gift_parent: props._gift_parent
            });
          }
        });
        /* Step 2: tag DOM elements based on data-index match */
        tagGiftLinesInDom();
      })
      .catch(function () {});
  }

  function tagGiftLinesInDom() {
    /* V5.0.4: REWRITE — Old logic used document.querySelector which returns
       only ONE element. When 2 gifts share same variant_id (e.g. customer
       picks same color twice), only first line got tagged → second leaked
       discount badge. NEW: iterate ALL line items in DOM, queue-match each
       to a gift key by data-index OR variant_id (whichever matches first
       remaining gift in queue). Works for both cart drawer AND cart page. */
    if (giftLineKeys.length === 0) {
      /* Still clear stale tags even when no gifts (cart was emptied) */
      document.querySelectorAll('.sh-gift-line-item').forEach(function (el) {
        el.classList.remove('sh-gift-line-item');
        el.removeAttribute('data-locked');
        el.removeAttribute('data-gift-label');
        el.removeAttribute('data-gift-line-key');
      });
      return;
    }
    var cfg = loadConfig();
    var giftLabel = L(cfg, 'gift_label');

    /* Clear stale tags first */
    document.querySelectorAll('.sh-gift-line-item').forEach(function (el) {
      el.classList.remove('sh-gift-line-item');
      el.removeAttribute('data-locked');
      el.removeAttribute('data-gift-label');
      el.removeAttribute('data-gift-line-key');
    });

    /* Get ALL line items in DOM (cart drawer + cart page).
       V5.0.5: Added .hdt-page-cart__item explicitly + tr[id^="CartItem-"]
       for cart page table rows. */
    var allLines = document.querySelectorAll(
      '.hdt-line-item, .hdt-cart-item, .hdt-page-cart__item, ' +
      '.hdt-mini-cart__item, .cart-item, [class*="cart-line"], ' +
      'tr[id^="CartItem-"]'
    );

    /* Dedupe: a single line can match multiple selectors above */
    var seen = new Set();
    var dedupedLines = [];
    allLines.forEach(function (el) {
      if (!seen.has(el)) { seen.add(el); dedupedLines.push(el); }
    });

    /* V5.0.9: FILTER OUTERMOST ONLY.
       Cart page nests <div class="hdt-line-item"> INSIDE <tr class="hdt-cart-item">.
       Both match our selector. If we iterate both, the inner div consumes a
       queue entry meant for a different outer tr → last gift row gets nothing.
       Fix: drop any line whose ancestor is also in dedupedLines. */
    var lineSet = new Set(dedupedLines);
    var uniqueLines = dedupedLines.filter(function (line) {
      var p = line.parentElement;
      while (p) {
        if (lineSet.has(p)) return false; /* has ancestor in set → drop */
        p = p.parentElement;
      }
      return true;
    });

    /* Queue of unmatched gift keys — each can be matched only ONCE */
    var giftQueue = giftLineKeys.slice();

    uniqueLines.forEach(function (line) {
      if (giftQueue.length === 0) return;

      /* Extract this line's identifying info */
      var qtyInput = line.querySelector('input[data-index], [data-line-item-index]');
      var lineIndex = null;
      if (qtyInput) {
        var raw = qtyInput.dataset.index || qtyInput.dataset.lineItemIndex;
        if (raw) lineIndex = parseInt(raw, 10);
      }
      var variantId = null;
      var link = line.querySelector('a[href*="variant="]');
      if (link) {
        var m = link.href.match(/variant=(\d+)/);
        if (m) variantId = parseInt(m[1], 10);
      }

      /* Find first matching gift in queue.
         Priority 1: data-index match (unique per line — most reliable)
         Priority 2: variant_id match (fallback — first gift with this variant) */
      var matchIdx = -1;
      if (lineIndex != null) {
        for (var i = 0; i < giftQueue.length; i++) {
          if (giftQueue[i].index === lineIndex) { matchIdx = i; break; }
        }
      }
      if (matchIdx === -1 && variantId != null) {
        for (var j = 0; j < giftQueue.length; j++) {
          if (giftQueue[j].variant_id === variantId) { matchIdx = j; break; }
        }
      }

      if (matchIdx !== -1) {
        var matched = giftQueue.splice(matchIdx, 1)[0];
        line.classList.add('sh-gift-line-item');
        line.setAttribute('data-gift-label', giftLabel);
        line.setAttribute('data-locked', 'true');
        line.setAttribute('data-gift-line-key', matched.key);
        hideDiscountTagsIn(line);
      }
    });
  }

  /* SAFE: only hide actual Halo discount markup INSIDE a confirmed gift line.
     Halo's structure (from cart-drawer.liquid):
       <ul class="hdt-discounts hdt-mini-cart__discount-price">
         <li class="hdt-discounts__discount">{icon} {discount.title}</li>
       </ul>
     OR the cart-totals discount block. We target ONLY these. */
  function hideDiscountTagsIn(line) {
    var sels = [
      '.hdt-discounts',
      '.hdt-mini-cart__discount-price',
      '.hdt-cart_discounts',
      '.hdt-discounts__discount',
      '.hdt-discount-item',
      '.hdt-discount-title'
    ];
    sels.forEach(function (sel) {
      line.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('data-sh-hide-discount', '');
      });
    });
  }
  /* Debounced triggers to avoid hammering /cart/change.js + /cart.js */
  var syncTimer = null;
  function scheduleSync(delay) {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncGiftQuantities();
    }, delay || 350);
  }
  var scanTimer = null;
  function scheduleScan(delay) {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scanCartForGifts();
    }, delay || 400);
  }

  function setupCartObserver() {
    /* V5.0.4: Watch BOTH cart drawer AND cart page (/cart).
       Cart page didn't have an observer before — gift discount badge
       leaked because scan never re-ran after AJAX qty updates there. */
    var drawerAttached = false;
    var pageAttached = false;

    function attachDrawerObserver() {
      if (drawerAttached) return;
      var drawer = document.querySelector('hdt-cart-drawer, cart-drawer, [id*="CartDrawer"]');
      if (!drawer) return;
      var observer = new MutationObserver(function () {
        scheduleScan(400);
        scheduleSync(500);
      });
      observer.observe(drawer, { childList: true, subtree: true });
      drawerAttached = true;
    }

    function attachPageObserver() {
      if (pageAttached) return;
      /* V5.0.5: Cart page targets — Halo's actual structure:
         <hdt-main-cart class="hdt-page-cart" id="hdt-page-cart">...</hdt-main-cart>
         Previous V5.0.4 used .hdt-cart-page (wrong word order) — never matched. */
      var page = document.querySelector(
        'hdt-main-cart, .hdt-page-cart, #hdt-page-cart, main-cart, form[action="/cart"], form#CartPage-Form'
      );
      if (!page) return;
      var observer = new MutationObserver(function () {
        scheduleScan(400);
      });
      observer.observe(page, { childList: true, subtree: true });
      pageAttached = true;
    }

    attachDrawerObserver();
    attachPageObserver();

    /* Retry attaching periodically (lazy load) */
    var attachInterval = setInterval(function () {
      attachDrawerObserver();
      attachPageObserver();
      if (drawerAttached && pageAttached) clearInterval(attachInterval);
    }, 1000);

    document.addEventListener('cart:refresh', function () {
      scheduleScan(200);
      scheduleSync(400);
    });
    document.addEventListener('cart:updated', function () {
      scheduleScan(200);
      scheduleSync(400);
    });

    /* V5.0.6: Aggressive scanning on /cart page, but route through
       scheduleScan() for proper debouncing. Avoids racing with user-
       triggered cart updates (e.g. clicking +/- on parent qty). */
    var isCartPage = /^\/cart(\/|\?|$)/.test(location.pathname);
    if (isCartPage) {
      /* Stagger scans: 400ms, 1.2s, 3s — debounce auto-collapses overlap */
      setTimeout(function () { scheduleScan(0); }, 400);
      setTimeout(function () { scheduleScan(0); }, 1200);
      setTimeout(function () { scheduleScan(0); }, 3000);
    } else {
      setTimeout(scanCartForGifts, 1000);
      setTimeout(scanCartForGifts, 2500);
    }
  }
  function setupCartProtection() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sh-gift-line-item[data-locked="true"]')) {
        e.preventDefault();
        e.stopPropagation();
        showToast(getLocale() === 'en' ? '🎁 Gift items cannot be modified' : '🎁 ของแถมไม่สามารถแก้ไขได้');
      }
    }, true);
  }

  /* ===== AUTO-BYPASS REQUIRED AGREE CHECKBOX =====
     The cart drawer has a hidden "I agree with terms" checkbox marked `required`.
     We hide it visually via CSS, but must remove the `required` attribute AND
     force-check it so Halo's form submit + checkout flow work. */
  function bypassAgreeCheckbox() {
    document.querySelectorAll('input[name="agree_checkbox"], .hdt-cart-checkbox input[type="checkbox"]').forEach(function (cb) {
      if (cb.hasAttribute('required')) cb.removeAttribute('required');
      if (!cb.checked) {
        cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    /* Also clear Halo's <hdt-block-required> gate by setting detect state */
    document.querySelectorAll('hdt-block-required[detect="checked"]').forEach(function (el) {
      try {
        el.setAttribute('data-sh-bypassed', '1');
        /* Halo uses this element to block checkout — mark as satisfied */
        var inner = el.querySelector('input[type="checkbox"]');
        if (inner && !inner.checked) {
          inner.checked = true;
          inner.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {}
    });
  }

  /* ===== GIFT READINESS GUARD =====
     Returns false if customer has gifts that need selection but hasn't picked.
     Used to block ATC click when gifts are not ready. */
  function areGiftsReady() {
    var cfg = loadConfig();
    if (!cfg || !isProductTargeted(cfg)) return true;
    var p = getCurrentProduct();
    if (!p) return true;
    var vid = getCurrentVariantId();
    var pq = getParentQuantity();
    var rules = getApplicableRules(vid, { includeThreshold: false });
    for (var i = 0; i < rules.length; i++) {
      var gs = rules[i].gifts || [];
      for (var j = 0; j < gs.length; j++) {
        var g = gs[j];
        if (!g.let_customer_choose) continue;
        if (g.has_only_default_variant) continue;
        var key = (rules[i].id || 'rule') + '__' + j + '__' + g.product_id;
        var instCount = getGiftInstanceCount(g, pq);
        /* Try to auto-lock first (in case render hasn't fired yet) */
        autoLockSizeOption(g, key, instCount);
        autoSelectSingleValueOptions(g, key, instCount);
        var ids = getGiftVariantIds(g, key, instCount);
        if (ids.some(function (id) { return !id; })) return false;
      }
    }
    return true;
  }

  function scrollToGiftCard() {
    var mount = document.querySelector('[data-sh-gift-mount]');
    if (!mount) return;
    try { mount.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    var card = mount.querySelector('.sh-gift-card');
    if (card) {
      card.classList.add('sh-gift-card--shake');
      setTimeout(function () { card.classList.remove('sh-gift-card--shake'); }, 700);
    }
  }

  /* Block sticky ATC bar (mobile) if gifts not ready */
  function setupStickyAtcGuard() {
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      /* Match: any "add to cart" button INSIDE the sticky bar */
      var btn = e.target.closest && e.target.closest(
        '#sh-pdp-sticky button, .sh-psb button, ' +
        '#sh-pdp-sticky [class*="add"], .sh-psb [class*="add"], ' +
        'hdt-sticky-btn-atc button[name="add"]'
      );
      if (!btn) return;
      /* Only block "add to cart"-like buttons, not buy-now or others */
      var txt = (btn.textContent || '').trim();
      var isAtc = /หยิบ|เพิ่ม|ตะกร้า|cart|add/i.test(txt) ||
                  btn.getAttribute('name') === 'add' ||
                  /add/i.test(btn.className);
      if (!isAtc) return;
      if (areGiftsReady()) return;
      /* Block click + alert customer */
      e.preventDefault();
      e.stopImmediatePropagation();
      var loc = getLocale();
      showToast(loc === 'en'
        ? '⚠ Please choose your free gift options first'
        : '⚠ กรุณาเลือกตัวเลือกของแถมก่อน');
      scrollToGiftCard();
    }, true); /* CAPTURE phase — runs BEFORE Halo's handler */
  }

  /* PERF: Pre-warm discount cookie at page load → ATC doesn't need to apply */
  function warmupDiscount(cfg) {
    var code = cfg && cfg.behavior && cfg.behavior.free_gift_discount_code;
    if (!code) return;
    if (window.__shDiscountApplied) return;
    /* Check sessionStorage to avoid re-warming on every page nav */
    try {
      var key = 'sh_discount_warmed_' + code;
      if (sessionStorage.getItem(key) === '1') {
        window.__shDiscountApplied = true;
        return;
      }
      /* Apply silently in background — won't block page render */
      setTimeout(function () {
        applyDiscountCode(code).then(function () {
          window.__shDiscountApplied = true;
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
          _shLog('[SH Promo] discount cookie warmed:', code);
        });
      }, 800); /* delay 800ms so page-critical fetches finish first */
    } catch (e) {}
  }

  function init() {
    var cfg = loadConfig();
    if (!cfg || cfg.enabled === false) return;
    setupATCHook();
    setupCartObserver();
    setupCartProtection();
    if (getCurrentProduct() && isProductTargeted(cfg)) {
      setupVariantListener();
      setupStickyAtcGuard(); /* Block sticky ATC if gifts not ready */
    }
    /* On page load, sync gifts to handle: ผ่อน parent qty มาก่อนหน้านี้,
       เปิดหน้าใหม่ แล้ว gift qty ยังไม่ตรง */
    setTimeout(syncGiftQuantities, 1500);

    /* V5.7 SECURITY: warmupDiscount disabled (code leak fix). Use Shopify Automatic Buy-X-Get-Y discount instead. */
    // warmupDiscount(cfg);

    /* Auto-bypass the hidden required "agree" checkbox (admin removed it) */
    bypassAgreeCheckbox();
    setTimeout(bypassAgreeCheckbox, 500);
    setTimeout(bypassAgreeCheckbox, 1500);
    /* Re-run whenever cart drawer updates */
    document.addEventListener('cart:refresh', bypassAgreeCheckbox);
    document.addEventListener('cart:updated', bypassAgreeCheckbox);
    setInterval(bypassAgreeCheckbox, 3000); /* safety net */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
